webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = exports.lan = exports.getParam = exports.eachLines = exports.transform = exports.maxPoint = exports.lastRecord = exports.StorageKey = exports.clearPoints = exports.blankMatrix = exports.blankLine = exports.fillLine = exports.delays = exports.speeds = exports.blockType = exports.origin = exports.blockShape = undefined;

var _keys = __webpack_require__(19);

var _keys2 = _interopRequireDefault(_keys);

var _i18n = __webpack_require__(183);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockShape = exports.blockShape = {
  I: [[1, 1, 1, 1]],
  L: [[0, 0, 1], [1, 1, 1]],
  J: [[1, 0, 0], [1, 1, 1]],
  Z: [[1, 1, 0], [0, 1, 1]],
  S: [[0, 1, 1], [1, 1, 0]],
  O: [[1, 1], [1, 1]],
  T: [[0, 1, 0], [1, 1, 1]]
};

var origin = exports.origin = {
  I: [[-1, 1], [1, -1]],
  L: [[0, 0]],
  J: [[0, 0]],
  Z: [[0, 0]],
  S: [[0, 0]],
  O: [[0, 0]],
  T: [[0, 0], [1, 0], [-1, 1], [0, -1]]
};

var blockType = exports.blockType = (0, _keys2.default)(blockShape);

var speeds = exports.speeds = [800, 650, 500, 370, 250, 160];

var delays = exports.delays = [50, 60, 70, 80, 90, 100];

var fillLine = exports.fillLine = ['I', 'I', 'I', 'I', 'I', 'I', 'I', 'I', 'I', 'I'];

var blankLine = exports.blankLine = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

var blankMatrix = exports.blankMatrix = function () {
  var matrix = [];
  for (var i = 0; i < 20; i++) {
    matrix.push(blankLine);
  }
  return matrix;
}();

var clearPoints = exports.clearPoints = [100, 300, 700, 1500];

var StorageKey = exports.StorageKey = 'VUE_TETRIS';

var lastRecord = exports.lastRecord = function () {
  var data = window.localStorage.getItem(StorageKey);
  if (!data) {
    return false;
  }
  try {
    if (window.btoa) {
      data = atob(data);
    }
    data = decodeURIComponent(data);
    data = JSON.parse(data);
  } catch (e) {
    if (window.console || window.console.error) {
      window.console.error('读取记录错误:', e);
    }
    return false;
  }
  return data;
}();

var maxPoint = exports.maxPoint = 999999;

var transform = exports.transform = function () {
  var trans = ['transform', 'webkitTransform', 'msTransform', 'mozTransform', 'oTransform'];
  var body = document.body;
  return trans.filter(function (e) {
    return body.style[e] !== undefined;
  })[0];
}();

var eachLines = exports.eachLines = 20;var getParam = exports.getParam = function getParam(param) {
  var r = new RegExp('\\?(?:.+&)?' + param + '=(.*?)(?:&.*)?$');
  var m = window.location.toString().match(r);
  return m ? decodeURI(m[1]) : '';
};

var lan = exports.lan = function () {
  var l = getParam('lan').toLowerCase();
  if (!l && navigator.languages) {
    l = navigator.languages.find(function (l) {
      return _i18n2.default.lan.indexOf(l) !== -1;
    });
  }
  l = _i18n2.default.lan.indexOf(l) === -1 ? _i18n2.default.default : l;
  return l;
}();

document.title = _i18n2.default.data.title[lan];

var i18n = exports.i18n = _i18n2.default.data;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFocus = exports.visibilityChangeEvent = exports.subscribeRecord = exports.isOver = exports.isClear = exports.want = exports.isMobile = exports.getNextType = undefined;

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hiddenProperty = function () {
  var names = ['hidden', 'webkitHidden', 'mozHidden', 'msHidden'];
  names = names.filter(function (e) {
    return e in document;
  });
  return names.length > 0 ? names[0] : false;
}();
var unit = {
  getNextType: function getNextType() {
    var len = _const.blockType.length;
    return _const.blockType[Math.floor(Math.random() * len)];
  },
  want: function want(next, matrix) {
    var xy = next.xy;
    var shape = next.shape;
    var horizontal = shape[0].length;
    return shape.every(function (m, k1) {
      return m.every(function (n, k2) {
        if (xy[1] < 0) {
          return false;
        }
        if (xy[1] + horizontal > 10) {
          return false;
        }
        if (xy[0] + k1 < 0) {
          return true;
        }
        if (xy[0] + k1 >= 20) {
          return false;
        }
        if (n) {
          if (matrix[xy[0] + k1][xy[1] + k2]) {
            return false;
          }
          return true;
        }
        return true;
      });
    });
  },
  isClear: function isClear(matrix) {
    var clearLines = [];
    matrix.forEach(function (m, k) {
      if (m.every(function (n) {
        return !!n;
      })) {
        clearLines.push(k);
      }
    });
    if (clearLines.length === 0) {
      return false;
    }
    return clearLines;
  },
  isOver: function isOver(matrix) {

    return matrix[0].some(function (n) {
      return !!n;
    });
  },
  subscribeRecord: function subscribeRecord(store) {
    store.subscribe(function () {
      var data = store.state;
      if (data.lock) {
        return;
      }
      data = (0, _stringify2.default)(data);
      data = encodeURIComponent(data);
      if (window.btoa) {
        data = btoa(data);
      }
      window.localStorage.setItem(_const.StorageKey, data);
    });
  },
  isMobile: function isMobile() {
    var ua = navigator.userAgent;
    var android = /Android|Linux/i.test(ua);
    var iphone = /iPhone/i.test(ua);
    var ipod = /iPod/i.test(ua);
    var ipad = /iPad/i.test(ua);
    var mobile = /Mobile/i.test(ua);
    var nokiaN = ua.indexOf('NokiaN') > -1;
    return android || iphone || ipod || ipad || nokiaN || mobile;
  },

  visibilityChangeEvent: function () {
    if (!hiddenProperty) {
      return false;
    }
    return hiddenProperty.replace(/hidden/i, 'visibilitychange');
  }(),
  isFocus: function isFocus() {
    if (!hiddenProperty) {
      return true;
    }
    return !document[hiddenProperty];
  }
};
var getNextType = unit.getNextType,
    isMobile = unit.isMobile,
    want = unit.want,
    isClear = unit.isClear,
    isOver = unit.isOver,
    subscribeRecord = unit.subscribeRecord,
    visibilityChangeEvent = unit.visibilityChangeEvent,
    isFocus = unit.isFocus;
exports.getNextType = getNextType;
exports.isMobile = isMobile;
exports.want = want;
exports.isClear = isClear;
exports.isOver = isOver;
exports.subscribeRecord = subscribeRecord;
exports.visibilityChangeEvent = visibilityChangeEvent;
exports.isFocus = isFocus;

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _store = __webpack_require__(10);

var _store2 = _interopRequireDefault(_store);

var _unit = __webpack_require__(1);

var _const = __webpack_require__(0);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStartMatrix = function getStartMatrix(startLines) {
  var getLine = function getLine(min, max) {
    var count = parseInt((max - min + 1) * Math.random() + min, 10);
    var line = [];
    for (var i = 0; i < count; i++) {
      line.push(_const.blockType[Math.floor(Math.random() * _const.blockType.length)]);
    }
    for (var _i = 0, len = 10 - count; _i < len; _i++) {
      var index = parseInt((line.length + 1) * Math.random(), 10);
      line.splice(index, 0, 0);
    }

    return line;
  };
  var startMatrix = [];

  for (var i = 0; i < startLines; i++) {
    if (i <= 2) {
      startMatrix.push(getLine(5, 8));
    } else if (i <= 6) {
      startMatrix.push(getLine(4, 9));
    } else {
      startMatrix.push(getLine(3, 9));
    }
  }
  for (var _i2 = 0, len = 20 - startLines; _i2 < len; _i2++) {
    startMatrix.unshift(_const.blankLine);
  }
  return startMatrix;
};

var states = {
  fallInterval: null,

  start: function start() {
    if (_music.music.start) {
      _music.music.start();
    }
    var state = _store2.default.state;
    states.dispatchPoints(0);
    _store2.default.commit('speedRun', state.speedStart);
    var startLines = state.startLines;
    var startMatrix = getStartMatrix(startLines);
    _store2.default.commit('matrix', startMatrix);
    _store2.default.commit('moveBlock', { type: state.next });
    _store2.default.commit('nextBlock', '');
    states.auto();
  },

  auto: function auto(timeout) {
    var out = timeout < 0 ? 0 : timeout;
    var state = _store2.default.state;
    var cur = state.cur;
    var fall = function fall() {
      state = _store2.default.state;
      cur = state.cur;
      if (!cur) {
        return;
      }
      var next = cur.fall();
      if ((0, _unit.want)(next, state.matrix)) {
        _store2.default.commit('moveBlock', next);
        states.fallInterval = setTimeout(fall, _const.speeds[state.speedRun - 1]);
      } else {
        var matrix = JSON.parse((0, _stringify2.default)(state.matrix));
        var shape = cur && cur.shape;
        var xy = cur && cur.xy;
        shape.forEach(function (m, k1) {
          return m.forEach(function (n, k2) {
            if (n && xy[0] + k1 >= 0) {
              var line = matrix[xy[0] + k1];
              line[xy[1] + k2] = cur.type;
              matrix[xy[0] + k1] = line;
            }
          });
        });
        states.nextAround(matrix);
      }
    };
    clearTimeout(states.fallInterval);
    states.fallInterval = setTimeout(fall, out === undefined ? _const.speeds[state.speedRun - 1] : out);
  },

  nextAround: function nextAround(matrix, stopDownTrigger) {
    clearTimeout(states.fallInterval);
    _store2.default.commit('lock', true);
    _store2.default.commit('matrix', matrix);
    if (typeof stopDownTrigger === 'function') {
      stopDownTrigger();
    }

    var addPoints = _store2.default.state.points + 10 + (_store2.default.state.speedRun - 1) * 2;

    states.dispatchPoints(addPoints);

    if ((0, _unit.isClear)(matrix)) {
      if (_music.music.clear) {
        _music.music.clear();
      }
      return;
    }
    if ((0, _unit.isOver)(matrix)) {
      if (_music.music.gameover) {
        _music.music.gameover();
      }
      states.overStart();
      return;
    }
    setTimeout(function () {
      _store2.default.commit('lock', false);
      _store2.default.commit('moveBlock', { type: _store2.default.state.next });
      _store2.default.commit('nextBlock', '');
      states.auto();
    }, 100);
  },

  focus: function focus(isFocus) {
    _store2.default.commit('focus', isFocus);
    if (!isFocus) {
      clearTimeout(states.fallInterval);
      return;
    }
    var state = _store2.default.state;
    if (state.cur && !state.reset && !state.pause) {
      states.auto();
    }
  },

  pause: function pause(isPause) {
    _store2.default.commit('pause', isPause);
    if (isPause) {
      clearTimeout(states.fallInterval);
      return;
    }
    states.auto();
  },

  clearLines: function clearLines(matrix, lines) {
    var state = _store2.default.state;
    var newMatrix = JSON.parse((0, _stringify2.default)(matrix));
    lines.forEach(function (n) {
      newMatrix.splice(n, 1);

      newMatrix.unshift(_const.blankLine);
    });
    _store2.default.commit('matrix', newMatrix);
    _store2.default.commit('moveBlock', { type: state.next });
    _store2.default.commit('nextBlock', '');
    states.auto();
    _store2.default.commit('lock', false);
    var clearLines = state.clearLines + lines.length;
    _store2.default.commit('clearLines', clearLines);

    var addPoints = _store2.default.state.points + _const.clearPoints[lines.length - 1];
    states.dispatchPoints(addPoints);

    var speedAdd = Math.floor(clearLines / _const.eachLines);
    var speedNow = state.speedStart + speedAdd;
    speedNow = speedNow > 6 ? 6 : speedNow;
    _store2.default.commit('speedRun', speedNow);
  },

  overStart: function overStart() {
    clearTimeout(states.fallInterval);
    _store2.default.commit('lock', true);
    _store2.default.commit('reset', true);
    _store2.default.commit('pause', false);
  },

  overEnd: function overEnd() {
    _store2.default.commit('matrix', _const.blankMatrix);
    _store2.default.commit('moveBlock', { reset: true });
    _store2.default.commit('reset', false);
    _store2.default.commit('lock', false);
    _store2.default.commit('clearLines', 0);
  },

  dispatchPoints: function dispatchPoints(point) {
    _store2.default.commit('points', point);
    if (point > 0 && point > _store2.default.state.max) {
      _store2.default.commit('max', point);
    }
  }
};

exports.default = states;

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(19);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventName = {};

var down = function down(o) {
  var keys = (0, _keys2.default)(eventName);
  keys.forEach(function (i) {
    clearTimeout(eventName[i]);
    eventName[i] = null;
  });
  if (!o.callback) {
    return;
  }
  var clear = function clear() {
    clearTimeout(eventName[o.key]);
  };
  o.callback(clear);
  if (o.once === true) {
    return;
  }
  var begin = o.begin || 100;
  var interval = o.interval || 50;
  var loop = function loop() {
    eventName[o.key] = setTimeout(function () {
      begin = null;
      loop();
      o.callback(clear);
    }, begin || interval);
  };
  loop();
};

var up = function up(o) {
  clearTimeout(eventName[o.key]);
  eventName[o.key] = null;
  if (!o.callback) {
    return;
  }
  o.callback();
};

var clearAll = function clearAll() {
  var keys = (0, _keys2.default)(eventName);
  keys.forEach(function (i) {
    clearTimeout(eventName[i]);
    eventName[i] = null;
  });
};

exports.default = {
  down: down,
  up: up,
  clearAll: clearAll
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.music = exports.hasWebAudioAPI = undefined;

var _slicedToArray2 = __webpack_require__(93);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__(90);

var _promise2 = _interopRequireDefault(_promise);

var _store = __webpack_require__(10);

var _store2 = _interopRequireDefault(_store);

var _music = __webpack_require__(155);

var _music2 = _interopRequireDefault(_music);

var _move = __webpack_require__(154);

var _move2 = _interopRequireDefault(_move);

var _rotate = __webpack_require__(156);

var _rotate2 = _interopRequireDefault(_rotate);

var _fall = __webpack_require__(151);

var _fall2 = _interopRequireDefault(_fall);

var _clear = __webpack_require__(150);

var _clear2 = _interopRequireDefault(_clear);

var _gameover = __webpack_require__(152);

var _gameover2 = _interopRequireDefault(_gameover);

var _gamestart = __webpack_require__(153);

var _gamestart2 = _interopRequireDefault(_gamestart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext;

var hasWebAudioAPI = exports.hasWebAudioAPI = {
  data: !!AudioContext && location.protocol.indexOf('http') !== -1
};

var music = exports.music = {};(function () {
  if (!hasWebAudioAPI.data) {
    return;
  }
  var context = new AudioContext();

  var loadAudio = function loadAudio(url) {
    return new _promise2.default(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open('GET', url, true);
      req.responseType = 'arraybuffer';
      req.onload = function () {
        context.decodeAudioData(req.response, function (buf) {
          return resolve(buf);
        }, function (error) {
          return reject(error);
        });
      };
      req.onerror = function () {
        return reject(new Error('Network error loading ' + url));
      };
      req.send();
    });
  };

  _promise2.default.all([loadAudio(_music2.default), loadAudio(_move2.default), loadAudio(_rotate2.default), loadAudio(_fall2.default), loadAudio(_clear2.default), loadAudio(_gameover2.default), loadAudio(_gamestart2.default)]).then(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 7),
        musicBuf = _ref2[0],
        moveBuf = _ref2[1],
        rotateBuf = _ref2[2],
        fallBuf = _ref2[3],
        clearBuf = _ref2[4],
        gameoverBuf = _ref2[5],
        gamestartBuf = _ref2[6];

    var getSource = function getSource(buf) {
      var volume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;

      var source = context.createBufferSource();
      source.buffer = buf;
      if (volume !== 1.0) {
        var gainNode = context.createGain();
        gainNode.gain.value = volume;
        source.connect(gainNode);
        gainNode.connect(context.destination);
      } else {
        source.connect(context.destination);
      }
      return source;
    };

    music.killStart = function () {
      music.start = function () {};
    };

    music.start = function () {
      music.killStart();
      if (!_store2.default.state.music) {
        return;
      }
      getSource(gamestartBuf, 0.5).start(0);
    };

    music.clear = function () {
      if (!_store2.default.state.music) {
        return;
      }
      getSource(clearBuf, 0.5).start(0);
    };

    music.fall = function () {
      if (!_store2.default.state.music) {
        return;
      }
      getSource(fallBuf, 0.5).start(0);
    };

    music.gameover = function () {
      if (!_store2.default.state.music) {
        return;
      }
      getSource(gameoverBuf, 0.5).start(0);
    };

    music.rotate = function () {
      if (!_store2.default.state.music) {
        return;
      }
      getSource(rotateBuf, 0.5).start(0);
    };

    music.move = function () {
      if (!_store2.default.state.music) {
        return;
      }
      getSource(moveBuf).start(0);
    };
  }).catch(function (error) {
    if (window.console && window.console.error) {
      window.console.error('\u97F3\u9891\u8BFB\u53D6\u9519\u8BEF', error);
      hasWebAudioAPI.data = false;
    }
  });
})();

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(42);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(26);

var _vuex2 = _interopRequireDefault(_vuex);

var _unit = __webpack_require__(1);

var _mutations = __webpack_require__(84);

var _mutations2 = _interopRequireDefault(_mutations);

var _unit2 = __webpack_require__(1);

var _const = __webpack_require__(0);

var _block = __webpack_require__(43);

var _block2 = _interopRequireDefault(_block);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var clearLinesInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.clearLines, 10)) ? parseInt(_const.lastRecord.clearLines, 10) : 0;
if (clearLinesInitState < 0) {
  clearLinesInitState = 0;
}

var curInitState = function () {
  if (!_const.lastRecord || !_const.lastRecord.cur) {
    return null;
  }
  var cur = _const.lastRecord.cur;
  var option = {
    type: cur.type,
    rotateIndex: cur.rotateIndex,
    shape: cur.shape,
    xy: cur.xy
  };
  return new _block2.default(option);
}();

var dropInitState = _const.lastRecord && _const.lastRecord.drop !== undefined ? !!_const.lastRecord.drop : false;

var lockInitState = _const.lastRecord && _const.lastRecord.lock !== undefined ? !!_const.lastRecord.lock : false;

var matrixInitState = _const.lastRecord && Array.isArray(_const.lastRecord.matrix) ? _const.lastRecord.matrix : _const.blankMatrix;

var maxInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.max, 10)) ? parseInt(_const.lastRecord.max, 10) : 0;

if (maxInitState < 0) {
  maxInitState = 0;
} else if (maxInitState > _const.maxPoint) {
  maxInitState = _const.maxPoint;
}
var musicInitState = _const.lastRecord && _const.lastRecord.music !== undefined ? !!_const.lastRecord.music : true;
if (!_music.hasWebAudioAPI.data) {
  musicInitState = false;
}

var nextInitState = _const.lastRecord && _const.blockType.indexOf(_const.lastRecord.next) !== -1 ? _const.lastRecord.next : (0, _unit.getNextType)();

var pauseInitState = _const.lastRecord && _const.lastRecord.pause !== undefined ? !!_const.lastRecord.pause : false;

var pointsInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.points, 10)) ? parseInt(_const.lastRecord.points, 10) : 0;

if (pointsInitState < 0) {
  pointsInitState = 0;
} else if (pointsInitState > _const.maxPoint) {
  pointsInitState = _const.maxPoint;
}

var speedRunInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.speedRun, 10)) ? parseInt(_const.lastRecord.speedRun, 10) : 1;
if (speedRunInitState < 1 || speedRunInitState > 6) {
  speedRunInitState = 1;
}
var speedStartInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.speedStart, 10)) ? parseInt(_const.lastRecord.speedStart, 10) : 1;
if (speedStartInitState < 1 || speedStartInitState > 6) {
  speedStartInitState = 1;
}

var startLinesInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.startLines, 10)) ? parseInt(_const.lastRecord.startLines, 10) : 0;
if (startLinesInitState < 0 || startLinesInitState > 10) {
  startLinesInitState = 0;
}
var resetInitState = _const.lastRecord && _const.lastRecord.reset ? !!_const.lastRecord.reset : false;

var controlModeInitState = _const.lastRecord && _const.lastRecord.controlMode ? _const.lastRecord.controlMode : 'button';

var state = {
  music: musicInitState,
  pause: pauseInitState,
  matrix: matrixInitState,
  next: nextInitState,
  cur: curInitState,

  speedStart: speedStartInitState,
  speedRun: speedRunInitState,
  startLines: startLinesInitState,
  clearLines: clearLinesInitState,
  points: pointsInitState,
  max: maxInitState,
  reset: resetInitState,
  drop: dropInitState,
  keyboard: {
    drop: false,
    down: false,
    left: false,
    right: false,
    rotate: false,
    reset: false,
    music: false,
    pause: false
  },

  lock: lockInitState,
  controlMode: controlModeInitState,
  focus: (0, _unit2.isFocus)()
};
exports.default = new _vuex2.default.Store({
  state: state,

  mutations: _mutations2.default
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _left = __webpack_require__(75);

var _left2 = _interopRequireDefault(_left);

var _right = __webpack_require__(78);

var _right2 = _interopRequireDefault(_right);

var _down = __webpack_require__(74);

var _down2 = _interopRequireDefault(_down);

var _rotate = __webpack_require__(79);

var _rotate2 = _interopRequireDefault(_rotate);

var _space = __webpack_require__(81);

var _space2 = _interopRequireDefault(_space);

var _s = __webpack_require__(80);

var _s2 = _interopRequireDefault(_s);

var _r = __webpack_require__(77);

var _r2 = _interopRequireDefault(_r);

var _p = __webpack_require__(76);

var _p2 = _interopRequireDefault(_p);

var _x = __webpack_require__(82);

var _x2 = _interopRequireDefault(_x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  left: _left2.default,
  down: _down2.default,
  rotate: _rotate2.default,
  right: _right2.default,
  space: _space2.default,
  r: _r2.default,
  p: _p2.default,
  s: _s2.default,
  x: _x2.default
};

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(28);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(91);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(92);

var _createClass3 = _interopRequireDefault(_createClass2);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = function () {
  function Block(option) {
    (0, _classCallCheck3.default)(this, Block);

    this.type = option.type;

    if (!option.rotateIndex) {
      this.rotateIndex = 0;
    } else {
      this.rotateIndex = option.rotateIndex;
    }

    if (!option.timeStamp) {
      this.timeStamp = Date.now();
    } else {
      this.timeStamp = option.timeStamp;
    }

    if (!option.shape) {
      this.shape = _const.blockShape[option.type];
    } else {
      this.shape = option.shape;
    }
    if (!option.xy) {
      switch (option.type) {
        case 'I':
          this.xy = [0, 3];
          break;
        case 'L':
          this.xy = [-1, 4];
          break;
        case 'J':
          this.xy = [-1, 4];
          break;
        case 'Z':
          this.xy = [-1, 4];
          break;
        case 'S':
          this.xy = [-1, 4];
          break;
        case 'O':
          this.xy = [-1, 4];
          break;
        case 'T':
          this.xy = [-1, 4];
          break;
        default:
          break;
      }
    } else {
      this.xy = option.xy;
    }
  }

  (0, _createClass3.default)(Block, [{
    key: 'rotate',
    value: function rotate() {
      var shape = this.shape;
      var result = [];
      shape.forEach(function (m) {
        return m.forEach(function (n, k) {
          var index = m.length - k - 1;
          if (result[index] === undefined) {
            result[index] = [];
          }

          result[index].push(n);
          var tempK = [].concat((0, _toConsumableArray3.default)(result[index]));
          result[index] = tempK;
        });
      });
      var nextXy = [this.xy[0] + _const.origin[this.type][this.rotateIndex][0], this.xy[1] + _const.origin[this.type][this.rotateIndex][1]];
      var nextRotateIndex = this.rotateIndex + 1 >= _const.origin[this.type].length ? 0 : this.rotateIndex + 1;
      return {
        shape: result,
        type: this.type,
        xy: nextXy,
        rotateIndex: nextRotateIndex,
        timeStamp: this.timeStamp
      };
    }
  }, {
    key: 'fall',
    value: function fall() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return {
        shape: this.shape,
        type: this.type,
        xy: [this.xy[0] + n, this.xy[1]],
        rotateIndex: this.rotateIndex,
        timeStamp: Date.now()
      };
    }
  }, {
    key: 'right',
    value: function right() {
      return {
        shape: this.shape,
        type: this.type,
        xy: [this.xy[0], this.xy[1] + 1],
        rotateIndex: this.rotateIndex,
        timeStamp: this.timeStamp
      };
    }
  }, {
    key: 'left',
    value: function left() {
      return {
        shape: this.shape,
        type: this.type,
        xy: [this.xy[0], this.xy[1] - 1],
        rotateIndex: this.rotateIndex,
        timeStamp: this.timeStamp
      };
    }
  }]);
  return Block;
}();

exports.default = Block;

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(19);

var _keys2 = _interopRequireDefault(_keys);

var _store = __webpack_require__(10);

var _store2 = _interopRequireDefault(_store);

var _todo = __webpack_require__(18);

var _todo2 = _interopRequireDefault(_todo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyboard = {
  37: 'left',
  38: 'rotate',
  39: 'right',
  40: 'down',
  32: 'space',
  83: 's',
  82: 'r',
  80: 'p',
  88: 'x'
};

var keydownActive = void 0;

var boardKeys = (0, _keys2.default)(keyboard).map(function (e) {
  return parseInt(e, 10);
});

var keyDown = function keyDown(e) {
  if (e.metaKey === true || boardKeys.indexOf(e.keyCode) === -1) {
    return;
  }
  var type = keyboard[e.keyCode];
  if (type === keydownActive) {
    return;
  }
  keydownActive = type;
  _todo2.default[type].down(_store2.default);
};

var keyUp = function keyUp(e) {
  if (e.metaKey === true || boardKeys.indexOf(e.keyCode) === -1) {
    return;
  }
  var type = keyboard[e.keyCode];
  if (type === keydownActive) {
    keydownActive = '';
  }
  _todo2.default[type].up(_store2.default);
};

document.addEventListener('keydown', keyDown, true);
document.addEventListener('keyup', keyUp, true);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(27);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(26);

var _text = __webpack_require__(73);

__webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Sutra',
    data: function data() {
        return {
            fullText: _text.sutraText.replace(/\s+/g, ''),
            currentIndex: 0,
            historyText: '',
            activeChar: '',
            progress: 0,
            timer: null,
            lastClearLines: 0,
            offsetX: 0,
            isInstant: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['cur', 'pause', 'reset', 'clearLines']), {
        isGameRunning: function isGameRunning() {
            return !!this.cur && !this.pause && !this.reset;
        },
        contentStyle: function contentStyle() {
            return {
                transform: 'translateX(' + this.offsetX + 'px)'
            };
        },
        activeCharStyle: function activeCharStyle() {
            if (this.isInstant) {
                return {
                    height: 'auto',
                    transition: 'none'
                };
            }
            return {
                maxHeight: this.progress === 1 ? '1.5em' : '0em',
                transition: this.progress === 1 ? 'max-height 60s linear' : 'none',
                opacity: 1
            };
        }
    }),
    watch: {
        clearLines: function clearLines(newVal) {
            if (newVal > this.lastClearLines) {
                var diff = newVal - this.lastClearLines;
                this.handleClear(diff);
                this.lastClearLines = newVal;
            } else if (newVal < this.lastClearLines) {
                this.lastClearLines = newVal;
            }
        },
        reset: function reset(val) {
            if (val) {
                this.resetState();
            }
        },
        isGameRunning: function isGameRunning(newVal) {
            if (newVal) {
                this.startTypingLoop();
            } else {
                clearTimeout(this.timer);
            }
        }
    },
    mounted: function mounted() {
        if (this.isGameRunning) {
            this.startTypingLoop();
        }
        window.addEventListener('resize', this.updateScroll);
    },
    beforeDestroy: function beforeDestroy() {
        clearTimeout(this.timer);
        window.removeEventListener('resize', this.updateScroll);
    },

    methods: {
        resetState: function resetState() {
            clearTimeout(this.timer);
            this.currentIndex = 0;
            this.historyText = '';
            this.activeChar = '';
            this.progress = 0;
            this.offsetX = 0;
            this.lastClearLines = 0;
        },
        startTypingLoop: function startTypingLoop() {
            if (this.activeChar && this.currentIndex > 0) {
                this.currentIndex--;
            }
            this.nextChar(true);
        },
        nextChar: function nextChar() {
            var _this = this;

            var slow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this.currentIndex >= this.fullText.length) return;

            var char = this.fullText[this.currentIndex];
            this.activeChar = char;
            this.currentIndex++;

            this.isInstant = !slow;
            this.progress = 0;

            this.$nextTick(function () {
                if (slow) {
                    requestAnimationFrame(function () {
                        _this.progress = 1;
                        _this.updateScroll();
                    });
                    _this.timer = setTimeout(function () {
                        _this.commitChar();
                        _this.nextChar(true);
                    }, 60000);
                } else {
                    _this.progress = 1;
                    _this.commitChar();
                    _this.nextChar(true);
                }
            });
        },
        handleClear: function handleClear(lines) {
            clearTimeout(this.timer);
            this.commitChar();
            for (var i = 0; i < lines - 1; i++) {
                if (this.currentIndex < this.fullText.length) {
                    var char = this.fullText[this.currentIndex];
                    this.historyText += char;
                    this.currentIndex++;
                }
            }
            this.updateScroll();
            this.nextChar(true);
        },
        commitChar: function commitChar() {
            if (this.activeChar) {
                this.historyText += this.activeChar;
                this.activeChar = '';
                this.progress = 0;
                this.updateScroll();
            }
        },
        updateScroll: function updateScroll() {
            var _this2 = this;

            this.$nextTick(function () {
                var container = _this2.$refs.container;
                var wrapper = _this2.$refs.activeWrapper;

                if (container && wrapper) {
                    var cRect = container.getBoundingClientRect();
                    var wRect = wrapper.getBoundingClientRect();

                    if (wRect.left < cRect.left) {
                        var diff = cRect.left - wRect.left + 20;
                        _this2.offsetX += diff;
                    }
                }
            });
        }
    }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(27);

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__(157);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(158);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(163);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(162);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(164);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(56);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(165);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(166);

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__(160);

var _index18 = _interopRequireDefault(_index17);

var _index19 = __webpack_require__(161);

var _index20 = _interopRequireDefault(_index19);

var _index21 = __webpack_require__(167);

var _index22 = _interopRequireDefault(_index21);

var _index23 = __webpack_require__(159);

var _index24 = _interopRequireDefault(_index23);

var _vuex = __webpack_require__(26);

var _const = __webpack_require__(0);

var _unit = __webpack_require__(1);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

var _todo = __webpack_require__(18);

var _todo2 = _interopRequireDefault(_todo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  watch: {
    isMobile: {
      handler: function handler(val) {
        if (val) {
          document.body.classList.add('mobile-mode');
          document.body.classList.remove('pc-mode');
        } else {
          document.body.classList.remove('mobile-mode');
          document.body.classList.add('pc-mode');
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {
    this.render();
    window.addEventListener('resize', this.resize.bind(this), true);
  },
  data: function data() {
    return {
      size: {},
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
      filling: '',
      isMobile: (0, _unit.isMobile)(),
      touchStartX: 0,
      touchStartY: 0,
      touchLastX: 0,
      isLongPress: false,
      isSwiping: false,
      longPressTimeout: null
    };
  },

  components: {
    Decorate: _index2.default,
    Guide: _index4.default,
    Next: _index6.default,
    Music: _index8.default,
    Pause: _index10.default,
    Number: _index12.default,
    Point: _index14.default,
    Logo: _index18.default,
    Settings: _index16.default,
    Matrix: _index20.default,
    Sutra: _index22.default,
    Keyboard: _index24.default
  },
  computed: (0, _extends3.default)({
    pContent: function pContent() {
      return this.cur ? _const.i18n.cleans[_const.lan] : _const.i18n.startLine[_const.lan];
    },

    level: function level() {
      return _const.i18n.level[_const.lan];
    },
    nextText: function nextText() {
      return _const.i18n.next[_const.lan];
    }
  }, (0, _vuex.mapState)(['matrix', 'keyboard', 'music', 'pause', 'next', 'cur', 'speedStart', 'speedRun', 'startLines', 'clearLines', 'points', 'max', 'reset', 'drop', 'controlMode'])),
  methods: {
    render: function render() {
      var _this = this;

      var filling = 0;
      var size = function () {
        var w = _this.w;
        var h = _this.h;
        var ratio = h / w;
        var scale = void 0;
        var css = {};
        var baseHeight = _this.isMobile ? 1760 : 962;
        var ratioThreshold = baseHeight / 750;
        if (ratio < ratioThreshold) {
          scale = h / baseHeight;
          css = {
            'margin-top': Math.floor(-baseHeight / 2) + 'px'
          };
        } else {
          scale = w / 750;
          filling = (h - baseHeight * scale) / scale / 3;
          css = {
            'padding-top': Math.floor(filling) + 42 + 'px',
            'padding-bottom': '50px',
            'margin-top': Math.floor(-baseHeight / 2 - (filling * 1.5 - 50)) + 'px'
          };
        }
        css[_const.transform] = 'scale(' + scale + ')';
        return css;
      }();
      this.size = size;
      this.start();
      this.filling = filling;
    },
    resize: function resize() {
      this.w = document.documentElement.clientWidth;
      this.h = document.documentElement.clientHeight;
      this.isMobile = (0, _unit.isMobile)();
      this.render();
    },
    start: function start() {
      if (_unit.visibilityChangeEvent) {
        document.addEventListener(_unit.visibilityChangeEvent, function () {
          _states2.default.focus((0, _unit.isFocus)());
        }, false);
      }

      if (_const.lastRecord) {
        if (_const.lastRecord.cur && !_const.lastRecord.pause) {
          var speedRun = this.$store.state.speedRun;
          var timeout = _const.speeds[speedRun - 1] / 2;
          timeout = speedRun < _const.speeds[_const.speeds.length - 1] ? _const.speeds[_const.speeds.length - 1] : speedRun;
          _states2.default.auto(timeout);
        }

        if (!_const.lastRecord.cur) {
          _states2.default.overStart();
        }
      } else {
        _states2.default.overStart();
      }
    },
    onTouchStart: function onTouchStart(e) {
      var _this2 = this;

      if (!this.isMobile) return;
      if (this.controlMode === 'button') return;
      if (e.touches.length > 1) return;
      if (this.pause) return;

      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.touchLastX = this.touchStartX;
      this.isLongPress = false;
      this.isSwiping = false;

      this.longPressTimeout = setTimeout(function () {
        if (!_this2.isSwiping) {
          _this2.isLongPress = true;
          _todo2.default.down.down(_this2.$store);
        }
      }, 300);
    },
    onTouchMove: function onTouchMove(e) {
      if (!this.isMobile || this.pause) return;
      if (this.controlMode === 'button') return;
      if (e.touches.length > 1) return;

      e.preventDefault();

      var touchCurX = e.touches[0].clientX;
      var touchCurY = e.touches[0].clientY;
      var deltaX = touchCurX - this.touchStartX;
      var deltaY = touchCurY - this.touchStartY;

      if (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10) {
        if (!this.isSwiping) {
          this.isSwiping = true;
          clearTimeout(this.longPressTimeout);
          if (this.isLongPress) {
            _todo2.default.down.up(this.$store);
            this.isLongPress = false;
          }
        }

        var step = 40;
        if (touchCurX - this.touchLastX > step) {
          _todo2.default.right.down(this.$store);_todo2.default.right.up(this.$store);
          this.touchLastX += step;
        } else if (this.touchLastX - touchCurX > step) {
          _todo2.default.left.down(this.$store);_todo2.default.left.up(this.$store);
          this.touchLastX -= step;
        }
      }
    },
    onTouchEnd: function onTouchEnd(e) {
      if (!this.isMobile || this.pause) return;
      if (this.controlMode === 'button') return;

      clearTimeout(this.longPressTimeout);
      if (this.isLongPress) {
        _todo2.default.down.up(this.$store);
        this.isLongPress = false;
      } else if (!this.isSwiping) {
        _todo2.default.rotate.down(this.$store);_todo2.default.rotate.up(this.$store);
      } else {
        var touchCurX = e.changedTouches[0].clientX;
        var touchCurY = e.changedTouches[0].clientY;
        var deltaX = touchCurX - this.touchStartX;
        var deltaY = touchCurY - this.touchStartY;

        if (deltaY > 50 && Math.abs(deltaY) > Math.abs(deltaX)) {
          _todo2.default.space.down(this.$store);_todo2.default.space.up(this.$store);
        }
      }
    }
  }
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

exports.default = {
  name: 'Decorate',
  computed: {
    title: function title() {
      return _const.i18n.title[_const.lan];
    },
    github: function github() {
      return _const.i18n.github[_const.lan];
    },
    QRTitle: function QRTitle() {
      return _const.i18n.QRNotice[_const.lan];
    },
    QRCode: function QRCode() {
      return _const.i18n.QRCode[_const.lan];
    }
  }
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var _unit = __webpack_require__(1);

var _index = __webpack_require__(55);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Guide',
  components: {
    Vbutton: _index2.default
  },
  data: function data() {
    return {
      isMobile: (0, _unit.isMobile)()
    };
  },

  computed: {},
  mounted: function mounted() {
    window.addEventListener('resize', this.resize.bind(this), true);
  },

  methods: {
    resize: function resize() {
      this.isMobile = (0, _unit.isMobile)();
    }
  }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

exports.default = {
  props: ['active', 'color', 'size', 'top', 'left', 'label'],
  computed: {
    buttonStyle: function buttonStyle() {
      var topValue = typeof this.top === 'number' ? this.top + 'px' : this.top;
      var leftValue = typeof this.left === 'number' ? this.left + 'px' : this.left;
      return 'top:' + topValue + ';left:' + leftValue;
    }
  }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(19);

var _keys2 = _interopRequireDefault(_keys);

var _index = __webpack_require__(55);

var _index2 = _interopRequireDefault(_index);

var _const = __webpack_require__(0);

var _store = __webpack_require__(10);

var _store2 = _interopRequireDefault(_store);

var _todo = __webpack_require__(18);

var _todo2 = _interopRequireDefault(_todo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['filling'],
  data: function data() {
    return {
      fillingNum: 0
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.fillingNum = nextProps.filling;
      }
    }
  },
  computed: {
    keyboard: function keyboard() {
      return this.$store.state.keyboard;
    },

    rotation: function rotation() {
      return '旋';
    },
    labelLeft: function labelLeft() {
      return '左';
    },
    labelRight: function labelRight() {
      return '右';
    },
    labelDown: function labelDown() {
      return '下';
    },
    labelDropSpace: function labelDropSpace() {
      return '落';
    },
    labelResetR: function labelResetR() {
      return '复';
    },
    labelSoundS: function labelSoundS() {
      return '音';
    },
    labelPauseP: function labelPauseP() {
      return this.$store.state.pause ? '续' : '止';
    }
  },
  mounted: function mounted() {
    var _this = this;

    var touchEventCatch = {};
    var mouseDownEventCatch = {};
    document.addEventListener('touchstart', function () {}, true);
    document.addEventListener('touchend', function () {}, true);

    document.addEventListener('gesturestart', function (event) {
      event.preventDefault();
    });

    document.addEventListener('mousedown', function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
    }, true);
    (0, _keys2.default)(_todo2.default).forEach(function (key) {
      if (!_this.$refs['dom_' + key]) {
        return;
      }
      _this.$refs['dom_' + key].$el.addEventListener('mousedown', function () {
        if (touchEventCatch[key] === true) {
          return;
        }
        _todo2.default[key].down(_store2.default);
        mouseDownEventCatch[key] = true;
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('mouseup', function () {
        if (touchEventCatch[key] === true) {
          touchEventCatch[key] = false;
          return;
        }
        _todo2.default[key].up(_store2.default);
        mouseDownEventCatch[key] = false;
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('mouseout', function () {
        if (mouseDownEventCatch[key] === true) {
          _todo2.default[key].up(_store2.default);
        }
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('touchstart', function () {
        touchEventCatch[key] = true;
        _todo2.default[key].down(_store2.default);
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('touchend', function () {
        _todo2.default[key].up(_store2.default);
      }, true);
    });
  },

  components: {
    Vbutton: _index2.default
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = {
  timeout: null
};
exports.default = {
  props: ['cur', 'reset'],
  data: function data() {
    return {
      style: 'r1',
      display: 'none'
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps, oldProps) {
        this.animate(nextProps);
        if ([oldProps.cur, nextProps.cur].indexOf(false) !== -1 && oldProps.cur !== nextProps.cur || oldProps.reset !== nextProps.reset) {
          this.animate(nextProps);
        }
      }
    }
  },
  computed: {
    titleCenter: function titleCenter() {
      return _const.i18n.titleCenter[_const.lan];
    }
  },
  beforeMount: function beforeMount() {
    this.animate(this.$props);
  },

  methods: {
    animate: function animate(_ref) {
      var _this = this;

      var cur = _ref.cur,
          reset = _ref.reset;

      clearTimeout(Logo.timeout);
      this.style = 'r1';
      this.display = 'none';
      if (cur || reset) {
        this.display = 'none';
        return;
      }

      var m = 'r';
      var count = 0;

      var set = function set(func, delay) {
        if (!func) {
          return;
        }
        Logo.timeout = setTimeout(func, delay);
      };

      var show = function show(func) {
        set(function () {
          _this.display = 'block';
          if (func) {
            func();
          }
        }, 150);
      };

      var hide = function hide(func) {
        set(function () {
          _this.display = 'none';
          if (func) {
            func();
          }
        }, 150);
      };

      var eyes = function eyes(func, delay1, delay2) {
        set(function () {
          _this.style = m + 2;
          set(function () {
            _this.style = m + 1;
            if (func) {
              func();
            }
          }, delay2);
        }, delay1);
      };

      var run = function run(func) {
        set(function () {
          _this.style = m + 4;
          set(function () {
            _this.style = m + 3;
            count++;
            if (count === 10 || count === 20 || count === 30) {
              m = m === 'r' ? 'l' : 'r';
            }
            if (count < 40) {
              run(func);
              return;
            }
            _this.style = m + 1;
            if (func) {
              set(func, 4000);
            }
          }, 100);
        }, 100);
      };

      var dra = function dra() {
        count = 0;
        eyes(function () {
          eyes(function () {
            eyes(function () {
              _this.style = m + 2;
              run(dra);
            }, 150, 150);
          }, 150, 150);
        }, 1000, 1500);
      };

      show(function () {
        hide(function () {
          show(function () {
            hide(function () {
              show(function () {
                dra();
              });
            });
          });
        });
      });
    },
    start: function start() {
      _states2.default.start();
    }
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(28);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _unit = __webpack_require__(1);

var _const = __webpack_require__(0);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var t = setTimeout;
exports.default = {
  props: ['cur', 'reset', 'propMatrix'],
  watch: {
    $props: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var oldVal = arguments[1];

        this.propsChange(val);
      },

      deep: true
    }
  },
  render: function render() {
    var h = arguments[0];

    var matrix = void 0;
    if (this.isOver) {
      matrix = this.overState;
    } else {
      matrix = this.getResult();
    }

    return h(
      'div',
      { 'class': 'matrix' },
      [matrix.map(function (p, k1) {
        return h(
          'p',
          null,
          [p.map(function (e, k2) {
            var className = '';
            var text = '德';
            if (e === 2) {
              className = 'd';
            } else if (typeof e === 'string' && e.endsWith('_active')) {
              var type = e.split('_')[0];
              className = 'active type-' + type;
              text = '德';
            } else if (typeof e === 'string' && e.endsWith('_ghost')) {
              var _type = e.split('_')[0];
              className = 'ghost type-' + _type;
              text = '德';
            } else if (e) {
              var _type2 = e === 1 ? 'I' : e;
              className = 'c type-' + _type2;
            }
            return h(
              'b',
              { 'class': className },
              [text]
            );
          })]
        );
      })]
    );
  },
  data: function data() {
    return {
      clearLines: false,
      animateColor: 2,
      isOver: false,
      overState: null
    };
  },

  methods: {
    propsChange: function propsChange(nextProps) {
      var _this = this;

      var clears = (0, _unit.isClear)(nextProps.propMatrix);
      var overs = nextProps.reset;
      setTimeout(function () {
        _this.clearLines = clears;
        _this.isOver = overs;
      }, 0);
      if (clears && !this.clearLines) {
        this.clearAnimate(clears);
      }
      if (!clears && overs && !this.isOver) {
        this.over(nextProps);
      }
    },
    getResult: function getResult(props) {
      if (!props) {
        props = this.$props;
      }
      var cur = props.cur;
      var shape = cur && cur.shape;
      var xy = cur && cur.xy;
      var matrix = JSON.parse((0, _stringify2.default)(props.propMatrix));
      var clearLines = this.clearLines;
      if (clearLines) {
        var animateColor = this.animateColor;
        clearLines.forEach(function (index) {
          matrix[index] = [animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor];
        });
      } else if (shape) {
        var ghostY = xy[0];
        while ((0, _unit.want)({ shape: shape, xy: [ghostY + 1, xy[1]] }, props.propMatrix)) {
          ghostY++;
        }

        if (ghostY > xy[0]) {
          shape.forEach(function (m, k1) {
            return m.forEach(function (n, k2) {
              if (n && ghostY + k1 >= 0) {
                var line = matrix[ghostY + k1];
                if (line && !line[xy[1] + k2]) {
                  line[xy[1] + k2] = cur.type + '_ghost';
                  matrix[ghostY + k1] = line;
                }
              }
            });
          });
        }

        shape.forEach(function (m, k1) {
          return m.forEach(function (n, k2) {
            if (n && xy[0] + k1 >= 0) {
              var line = matrix[xy[0] + k1];
              var color = void 0;

              var isGhost = line[xy[1] + k2] && typeof line[xy[1] + k2] === 'string' && line[xy[1] + k2].endsWith('_ghost');

              color = cur.type + '_active';

              line[xy[1] + k2] = color;
              matrix[xy[0] + k1] = line;
            }
          });
        });
      }
      return matrix;
    },
    clearAnimate: function clearAnimate() {
      var _this2 = this;

      this.animateColor = 2;
      t(function () {
        _states2.default.clearLines(_this2.propMatrix, _this2.clearLines);
      }, 600);
    },
    over: function over(nextProps) {
      var _this3 = this;

      var overState = this.getResult(nextProps);

      this.overState = [].concat((0, _toConsumableArray3.default)(overState));
      var exLine = function exLine(index) {
        if (index <= 19) {
          overState[19 - index] = _const.fillLine;
        } else if (index >= 20 && index <= 39) {
          overState[index - 20] = _const.blankLine;
        } else {
          _states2.default.overEnd();
          return;
        }
        _this3.overState = [].concat((0, _toConsumableArray3.default)(overState));
      };

      for (var i = 0; i <= 40; i++) {
        t(exLine.bind(null, i), 40 * (i + 1));
      }
    }
  }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['data']
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(28);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var xy = {
  I: [1, 0],
  L: [0, 0],
  J: [0, 0],
  Z: [0, 0],
  S: [0, 0],
  O: [0, 1],
  T: [0, 0]
};
var empty = [[0, 0, 0, 0], [0, 0, 0, 0]];

exports.default = {
  props: ['data'],
  mounted: function mounted() {
    this.build(this.data);
  },
  data: function data() {
    return {
      block: empty
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.build(nextProps.data);
      }
    }
  },
  methods: {
    build: function build(type) {
      var shape = _const.blockShape[type];
      var block = empty.map(function (e) {
        return [].concat((0, _toConsumableArray3.default)(e));
      });
      shape.forEach(function (m, k1) {
        m.forEach(function (n, k2) {
          if (n) {
            block[k1 + xy[type][0]][k2 + xy[type][1]] = type;
          }
        });
      });
      this.block = block;
    }
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var numMap = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
var toChinese = function toChinese(num) {
  return ('' + num).split('').map(function (n) {
    return isNaN(parseInt(n)) ? n : numMap[parseInt(n)];
  }).join('');
};

var formate = function formate(num) {
  return (num < 10 ? '0' + num : '' + num).split('').map(function (n) {
    return numMap[parseInt(n)];
  });
};
var NumberObj = {
  timeInterval: null,
  time_count: null
};
exports.default = {
  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.render();
      }
    }
  },
  props: {
    propTime: {
      type: Boolean
    },
    number: {
      type: Number
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      time_count: '',
      time: new Date(),
      data: []
    };
  },
  destroyed: function destroyed() {
    if (!this.propTime) {
      return;
    }
    clearTimeout(NumberObj.timeInterval);
  },

  methods: {
    render: function render() {
      if (this.propTime) {
        var now = this.time;
        var hour = formate(now.getHours());
        var min = formate(now.getMinutes());
        var sec = now.getSeconds() % 2;
        var t = hour.concat(sec ? 'd' : 'd_c', min);
        this.data = t;
        return;
      }
      var num = toChinese(this.number).split('');
      for (var i = 0, len = this.length - num.length; i < len; i++) {
        num.unshift('n');
      }
      this.data = num;
      return;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.length) {
      this.length = 6;
    }
    if (!this.propTime) {
      return;
    }
    var clock = function clock() {
      var count = +NumberObj.timeInterval;
      NumberObj.timeInterval = setTimeout(function () {
        _this.time = new Date();
        _this.time_count = count;
        _this.render();
        clock();
      }, 1000);
    };
    clock();
  },
  mounted: function mounted() {
    this.render();
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Pause = {
  timeout: null
};
exports.default = {
  props: ['data'],
  mounted: function mounted() {
    this.setShake(this.data);
  },
  data: function data() {
    return {
      showPause: false
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.setShake(nextProps.data);
      }
    }
  },
  methods: {
    setShake: function setShake(bool) {
      var _this = this;

      if (bool && !Pause.timeout) {
        Pause.timeout = setInterval(function () {
          _this.showPause = !_this.showPause;
        }, 250);
      }
      if (!bool && Pause.timeout) {
        clearInterval(Pause.timeout);
        this.showPause = false;
        Pause.timeout = null;
      }
    }
  }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var _index = __webpack_require__(56);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DF = _const.i18n.point[_const.lan];
var ZDF = _const.i18n.highestScore[_const.lan];
var SLDF = _const.i18n.lastRound[_const.lan];
var Point = {
  timeout: null
};
exports.default = {
  props: ['cur', 'point', 'max'],
  mounted: function mounted() {
    this.onChange(this.$props);
  },

  components: {
    Number: _index2.default
  },
  data: function data() {
    return {
      label: '',
      number: 0
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.onChange(nextProps);
      }
    }
  },
  methods: {
    onChange: function onChange(_ref) {
      var _this = this;

      var cur = _ref.cur,
          point = _ref.point,
          max = _ref.max;

      clearInterval(Point.timeout);
      if (cur) {
        this.label = point >= max ? ZDF : DF;
        this.number = point;
      } else {
        var toggle = function toggle() {
          _this.label = SLDF;
          _this.number = point;
          Point.timeout = setTimeout(function () {
            _this.label = ZDF;
            _this.number = max;
            Point.timeout = setTimeout(toggle, 3000);
          }, 3000);
        };

        if (point !== 0) {
          toggle();
        } else {
          this.label = ZDF;
          this.number = max;
        }
      }
    }
  }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(27);

var _extends3 = _interopRequireDefault(_extends2);

var _store = __webpack_require__(10);

var _store2 = _interopRequireDefault(_store);

var _todo = __webpack_require__(18);

var _todo2 = _interopRequireDefault(_todo);

var _unit = __webpack_require__(1);

var _vuex = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      showMenu: false,
      isMobile: (0, _unit.isMobile)()
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['music', 'pause', 'points', 'controlMode'])),
  mounted: function mounted() {
    window.addEventListener('resize', this.resize.bind(this), true);
  },

  methods: {
    resize: function resize() {
      this.isMobile = (0, _unit.isMobile)();
    },
    toggleMenu: function toggleMenu() {
      this.showMenu = !this.showMenu;

      if (this.showMenu && !this.pause) {
        _todo2.default.p.down(_store2.default);
      } else if (!this.showMenu && this.pause) {
        _todo2.default.p.down(_store2.default);
      }
    },
    triggerAction: function triggerAction(type) {
      if (_todo2.default[type]) {
        _todo2.default[type].down(_store2.default);
        _todo2.default[type].up(_store2.default);

        if (type === 'r') {
          this.showMenu = false;
        }
      }
    },
    toggleControlMode: function toggleControlMode() {
      var targetMode = this.controlMode === 'button' ? 'touch' : 'button';
      _store2.default.commit('controlMode', targetMode);
    }
  }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var sutraText = exports.sutraText = "\n\u5982\u662F\u6211\u805E\u3002\u58F9\u6642\u4F5B\u5728\u820D\u885B\u570B\u3002\u7957\u6A39\u7D66\u5B64\u7368\u5712\u3002\u8207\u5927\u6BD4\u4E18\u773E\u3002\u5343\u4E8C\u767E\u4E94\u5341\u4EBA\u4FF1\u3002\u723E\u6642\u4E16\u5C0A\u3002\u98DF\u6642\u3002\u8457\u8863\u6301\u7F3D\u3002\u5165\u820D\u885B\u5927\u57CE\u4E5E\u98DF\u3002\u65BC\u5176\u57CE\u4E2D\u3002\u6B21\u7B2C\u4E5E\u5DF2\u3002\u9084\u81F3\u672C\u8655\u3002\u98EF\u98DF\u8A16\u3002\u6536\u8863\u7F3D\u3002\u6D17\u8DB3\u5DF2\u3002\u6577\u5EA7\u800C\u5750\u3002\n\n\u6642\u9577\u8001\u9808\u83E9\u63D0\u3002\u5728\u5927\u773E\u4E2D\u3002\u5373\u5F9E\u5EA7\u8D77\u3002\u504F\u8892\u53F3\u80A9\u3002\u53F3\u819D\u8457\u5730\u3002\u5408\u638C\u606D\u656C\u3002\u800C\u767D\u4F5B\u8A00\u3002\u5E0C\u6709\u4E16\u5C0A\u3002\u5982\u4F86\u5584\u8B77\u5FF5\u8AF8\u83E9\u85A9\u3002\u5584\u4ED8\u56D1\u8AF8\u83E9\u85A9\u3002\u4E16\u5C0A\u3002\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u3002\u61C9\u96F2\u4F55\u4F4F\uFF0C\u96F2\u4F55\u964D\u4F0F\u5176\u5FC3\u3002\u4F5B\u8A00\u3002\u5584\u54C9\u5584\u54C9\u3002\u9808\u83E9\u63D0\u3002\u5982\u6C5D\u6240\u8AAA\u3002\u5982\u4F86\u5584\u8B77\u5FF5\u8AF8\u83E9\u85A9\u3002\u5584\u4ED8\u56D1\u8AF8\u83E9\u85A9\u3002\u6C5D\u4ECA\u8AE6\u807D\u3002\u7576\u70BA\u6C5D\u8AAA\u3002\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u3002\u61C9\u5982\u662F\u4F4F\uFF0C\u5982\u662F\u964D\u4F0F\u5176\u5FC3\u3002\u552F\u7136\u3002\u4E16\u5C0A\u3002\u9858\u6A02\u6B32\u805E\u3002\n\n\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u8AF8\u83E9\u85A9\u6469\u8A36\u85A9\u3002\u61C9\u5982\u662F\u964D\u4F0F\u5176\u5FC3\u3002\u6240\u6709\u58F9\u5207\u773E\u751F\u4E4B\u985E\u3002\u82E5\u5375\u751F\u3002\u82E5\u80CE\u751F\u3002\u82E5\u6FD5\u751F\u3002\u82E5\u5316\u751F\u3002\u82E5\u6709\u8272\u3002\u82E5\u7121\u8272\u3002\u82E5\u6709\u60F3\u3002\u82E5\u7121\u60F3\u3002\u82E5\u975E\u6709\u60F3\u3002\u975E\u7121\u60F3\u3002\u6211\u7686\u4EE4\u5165\u7121\u4F59\u6D85\u76E4\u800C\u6EC5\u5EA6\u4E4B\u3002\u5982\u662F\u6EC5\u5EA6\u7121\u91CF\u7121\u6578\u7121\u908A\u773E\u751F\u3002\u5BE6\u7121\u773E\u751F\u5F97\u6EC5\u5EA6\u8005\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u82E5\u83E9\u85A9\u6709\u6211\u76F8\u3002\u4EBA\u76F8\u3002\u773E\u751F\u76F8\u3002\u58FD\u8005\u76F8\u3002\u5373\u975E\u83E9\u85A9\u3002\n\n\u5FA9\u6B21\u3002\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u65BC\u6CD5\u3002\u61C9\u7121\u6240\u4F4F\u884C\u65BC\u5E03\u65BD\u3002\u6240\u8B02\u4E0D\u4F4F\u8272\u5E03\u65BD\u3002\u4E0D\u4F4F\u8072\u9999\u5473\u89F8\u6CD5\u5E03\u65BD\u3002\u9808\u83E9\u63D0\uFF01\u83E9\u85A9\u61C9\u5982\u662F\u5E03\u65BD\u3002\u4E0D\u4F4F\u65BC\u76F8\u3002\u4F55\u4EE5\u6545\uFF1F\u82E5\u83E9\u85A9\u4E0D\u4F4F\u76F8\u5E03\u65BD\u3002\u5176\u798F\u5FB7\u4E0D\u53EF\u601D\u91CF\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u6771\u65B9\u865B\u7A7A\u53EF\u601D\u91CF\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u9808\u83E9\u63D0\u3002\u5357\u897F\u5317\u65B9\u3002\u56DB\u7DAD\u4E0A\u4E0B\u3002\u865B\u7A7A\u53EF\u601D\u91CF\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u7121\u4F4F\u76F8\u5E03\u65BD\u3002\u798F\u5FB7\u4EA6\u5FA9\u5982\u662F\u3002\u4E0D\u53EF\u601D\u91CF\u3002\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u4F46\u61C9\u5982\u6240\u6559\u4F4F\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u53EF\u4EE5\u8EAB\u76F8\u898B\u5982\u4F86\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4E0D\u53EF\u4EE5\u8EAB\u76F8\u5F97\u898B\u5982\u4F86\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u6240\u8AAA\u8EAB\u76F8\u3002\u5373\u975E\u8EAB\u76F8\u3002\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u51E1\u6240\u6709\u76F8\u3002\u7686\u662F\u865B\u5984\u3002\u82E5\u898B\u8AF8\u76F8\u975E\u76F8\u3002\u5373\u898B\u5982\u4F86\u3002\n\n\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u9817\u6709\u773E\u751F\u3002\u5F97\u805E\u5982\u662F\u8A00\u8AAA\u7AE0\u53E5\u3002\u751F\u5BE6\u4FE1\u4E0D\u3002\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u83AB\u4F5C\u662F\u8AAA\u3002\u5982\u4F86\u6EC5\u5F8C\u3002\u5F8C\u4E94\u767E\u6B72\u3002\u6709\u6301\u6212\u4FEE\u798F\u8005\u3002\u65BC\u6B64\u7AE0\u53E5\u3002\u80FD\u751F\u4FE1\u5FC3\u3002\u4EE5\u6B64\u70BA\u5BE6\u3002\u7576\u77E5\u662F\u4EBA\u3002\u4E0D\u65BC\u58F9\u4F5B\u4E8C\u4F5B\u4E09\u56DB\u4E94\u4F5B\u800C\u7A2E\u5584\u6839\u3002\u5DF2\u65BC\u7121\u91CF\u5343\u842C\u4F5B\u6240\u7A2E\u8AF8\u5584\u6839\u3002\u805E\u662F\u7AE0\u53E5\u3002\u4E43\u81F3\u58F9\u5FF5\u751F\u51C8\u4FE1\u8005\u3002\u9808\u83E9\u63D0\u3002\u5982\u4F86\u6089\u77E5\u6089\u898B\u3002\u662F\u8AF8\u773E\u751F\u3002\u5F97\u5982\u662F\u7121\u91CF\u798F\u5FB7\u3002\u4F55\u4EE5\u6545\u3002\u662F\u8AF8\u773E\u751F\u7121\u5FA9\u6211\u76F8\u3002\u4EBA\u76F8\u3002\u773E\u751F\u76F8\u3002\u58FD\u8005\u76F8\u3002\u7121\u6CD5\u76F8\u3002\u4EA6\u7121\u975E\u6CD5\u76F8\u3002\u4F55\u4EE5\u6545\u3002\u662F\u8AF8\u773E\u751F\u3002\u82E5\u5FC3\u53D6\u76F8\u3002\u5373\u70BA\u8457\u6211\u4EBA\u773E\u751F\u58FD\u8005\u3002\u82E5\u53D6\u6CD5\u76F8\u3002\u5373\u8457\u6211\u4EBA\u773E\u751F\u58FD\u8005\u3002\u4F55\u4EE5\u6545\u3002\u82E5\u53D6\u975E\u6CD5\u76F8\uFF0C\u5373\u8457\u6211\u4EBA\u773E\u751F\u58FD\u8005\u3002\u662F\u6545\u4E0D\u61C9\u53D6\u6CD5\u3002\u4E0D\u61C9\u53D6\u975E\u6CD5\u3002\u4EE5\u662F\u7FA9\u6545\u3002\u5982\u4F86\u5E38\u8AAA\u3002\u6C5D\u7B49\u6BD4\u4E18\u3002\u77E5\u6211\u8AAA\u6CD5\u3002\u5982\u7B4F\u55BB\u8005\u3002\u6CD5\u5C1A\u61C9\u820D\u3002\u4F55\u6CC1\u975E\u6CD5\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u8036\u3002\u5982\u4F86\u6709\u6240\u8AAA\u6CD5\u8036\u3002\u9808\u83E9\u63D0\u8A00\u3002\u5982\u6211\u89E3\u4F5B\u6240\u8AAA\u7FA9\u3002\u7121\u6709\u5B9A\u6CD5\u3002\u540D\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u4EA6\u7121\u6709\u5B9A\u6CD5\u3002\u5982\u4F86\u53EF\u8AAA\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u6240\u8AAA\u6CD5\u3002\u7686\u4E0D\u53EF\u53D6\u3002\u4E0D\u53EF\u8AAA\u3002\u975E\u6CD5\u975E\u975E\u6CD5\u3002\u6240\u4EE5\u8005\u4F55\u3002\u58F9\u5207\u8CE2\u8056\uFF0C\u7686\u4EE5\u7121\u70BA\u6CD5\u800C\u6709\u5DEE\u5225\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u82E5\u4EBA\u6EFF\u4E09\u5343\u5927\u5343\u4E16\u754C\u4E03\u5BF6\u3002\u4EE5\u7528\u5E03\u65BD\u3002\u662F\u4EBA\u6240\u5F97\u798F\u5FB7\u3002\u5BE7\u70BA\u591A\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u751A\u591A\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u662F\u798F\u5FB7\u5373\u975E\u798F\u5FB7\u6027\u3002\u662F\u6545\u5982\u4F86\u8AAA\u798F\u5FB7\u591A\u3002\u82E5\u5FA9\u6709\u4EBA\u3002\u65BC\u6B64\u7D93\u4E2D\u53D7\u6301\u4E43\u81F3\u56DB\u53E5\u5048\u7B49\u3002\u70BA\u4ED6\u4EBA\u8AAA\u3002\u5176\u798F\u52DD\u5F7C\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u58F9\u5207\u8AF8\u4F5B\u3002\u53CA\u8AF8\u4F5B\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u6CD5\u3002\u7686\u5F9E\u6B64\u7D93\u51FA\u3002\u9808\u83E9\u63D0\u3002\u6240\u8B02\u4F5B\u6CD5\u8005\u3002\u5373\u975E\u4F5B\u6CD5\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u9808\u9640\u6D39\u80FD\u4F5C\u662F\u5FF5\u3002\u6211\u5F97\u9808\u9640\u6D39\u679C\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u9808\u9640\u6D39\u540D\u70BA\u5165\u6D41\u3002\u800C\u7121\u6240\u5165\u3002\u4E0D\u5165\u8272\u8072\u9999\u5473\u89F8\u6CD5\u3002\u662F\u540D\u9808\u9640\u6D39\uFF0C\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u65AF\u9640\u542B\u80FD\u4F5C\u662F\u5FF5\u3002\u6211\u5F97\u65AF\u9640\u542B\u679C\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u65AF\u9640\u542B\u540D\u58F9\u5F80\u4F86\u3002\u800C\u5BE6\u7121\u5F80\u4F86\u3002\u662F\u540D\u65AF\u9640\u542B\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u963F\u90A3\u542B\u80FD\u4F5C\u662F\u5FF5\u3002\u6211\u5F97\u963F\u90A3\u542B\u679C\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u963F\u90A3\u542B\u540D\u70BA\u4E0D\u4F86\uFF0C\u800C\u5BE6\u7121\u4E0D\u4F86\u3002\u662F\u6545\u540D\u963F\u90A3\u542B\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u963F\u7F85\u6F22\u80FD\u4F5C\u662F\u5FF5\u3002\u6211\u5F97\u963F\u7F85\u6F22\u9053\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u5BE6\u7121\u6709\u6CD5\u540D\u963F\u7F85\u6F22\u3002\u4E16\u5C0A\u3002\u82E5\u963F\u7F85\u6F22\u4F5C\u662F\u5FF5\u3002\u6211\u5F97\u963F\u7F85\u6F22\u9053\u3002\u5373\u70BA\u8457\u6211\u4EBA\u773E\u751F\u58FD\u8005\u3002\u4E16\u5C0A\u3002\u4F5B\u8AAA\u6211\u5F97\u7121\u8ACD\u4E09\u6627\u3002\u4EBA\u4E2D\u6700\u70BA\u7B2C\u58F9\u3002\u662F\u7B2C\u58F9\u96E2\u6B32\u963F\u7F85\u6F22\u3002\u4E16\u5C0A\u3002\u6211\u4E0D\u4F5C\u662F\u5FF5\u3002\u6211\u662F\u96E2\u6B32\u963F\u7F85\u6F22\u3002\u4E16\u5C0A\u3002\u6211\u82E5\u4F5C\u662F\u5FF5\u3002\u6211\u5F97\u963F\u7F85\u6F22\u9053\u3002\u4E16\u5C0A\u5247\u4E0D\u8AAA\u9808\u83E9\u63D0\u3002\u662F\u6A02\u963F\u862D\u90A3\u884C\u8005\u3002\u4EE5\u9808\u83E9\u63D0\u5BE6\u7121\u6240\u884C\u3002\u800C\u540D\u9808\u83E9\u63D0\u3002\u662F\u6A02\u963F\u862D\u90A3\u884C\u3002\n\n\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6614\u5728\u7136\u71C8\u4F5B\u6240\u3002\u65BC\u6CD5\u6709\u6240\u5F97\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u5728\u7136\u71C8\u4F5B\u6240\u3002\u65BC\u6CD5\u5BE6\u7121\u6240\u5F97\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u83E9\u85A9\u838A\u56B4\u4F5B\u571F\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u838A\u56B4\u4F5B\u571F\u8005\u3002\u5373\u975E\u838A\u56B4\u3002\u662F\u540D\u838A\u56B4\u3002\u662F\u6545\u9808\u83E9\u63D0\u3002\u8AF8\u83E9\u85A9\u6469\u8A36\u85A9\u3002\u61C9\u5982\u662F\u751F\u6E05\u51C8\u5FC3\u3002\u4E0D\u61C9\u4F4F\u8272\u751F\u5FC3\u3002\u4E0D\u61C9\u4F4F\u8072\u9999\u5473\u89F8\u6CD5\u751F\u5FC3\u3002\u61C9\u7121\u6240\u4F4F\u800C\u751F\u5176\u5FC3\u3002\u9808\u83E9\u63D0\u3002\u8B6C\u5982\u6709\u4EBA\u3002\u8EAB\u5982\u9808\u5F4C\u5C71\u738B\uFF0C\u65BC\u610F\u96F2\u4F55\u3002\u662F\u8EAB\u70BA\u5927\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u751A\u5927\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u4F5B\u8AAA\u975E\u8EAB\u3002\u662F\u540D\u5927\u8EAB\u3002\n\n\u9808\u83E9\u63D0\u3002\u5982\u6052\u6CB3\u4E2D\u6240\u6709\u6C99\u6578\u3002\u5982\u662F\u6C99\u7B49\u6052\u6CB3\u3002\u65BC\u610F\u96F2\u4F55\u3002\u662F\u8AF8\u6052\u6CB3\u6C99\u3002\u5BE7\u70BA\u591A\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u751A\u591A\u3002\u4E16\u5C0A\u3002\u4F46\u8AF8\u6052\u6CB3\u5C1A\u591A\u7121\u6578\u3002\u4F55\u6CC1\u5176\u6C99\u3002\u9808\u83E9\u63D0\u3002\u6211\u4ECA\u5BE6\u8A00\u544A\u6C5D\u3002\u82E5\u6709\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u4EE5\u4E03\u5BF6\u6EFF\u723E\u6240\u6052\u6CB3\u6C99\u6578\u4E09\u5343\u5927\u5343\u4E16\u754C\u3002\u4EE5\u7528\u5E03\u65BD\u3002\u5F97\u798F\u591A\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u751A\u591A\u3002\u4E16\u5C0A\u3002\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u82E5\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u65BC\u6B64\u7D93\u4E2D\u3002\u4E43\u81F3\u53D7\u6301\u56DB\u53E5\u5048\u7B49\u3002\u70BA\u4ED6\u4EBA\u8AAA\u3002\u800C\u6B64\u798F\u5FB7\u3002\u52DD\u524D\u798F\u5FB7\u3002\n\n\u5FA9\u6B21\u3002\u9808\u83E9\u63D0\u3002\u96A8\u8AAA\u662F\u7D93\u3002\u4E43\u81F3\u56DB\u53E5\u5048\u7B49\u3002\u7576\u77E5\u6B64\u8655\u3002\u58F9\u5207\u4E16\u9593\u5929\u4EBA\u963F\u4FEE\u7F85\u3002\u7686\u61C9\u4F9B\u990A\u3002\u5982\u4F5B\u5854\u5EDF\u3002\u4F55\u6CC1\u6709\u4EBA\u3002\u76E1\u80FD\u53D7\u6301\u8B80\u8AA6\u3002\u9808\u83E9\u63D0\u3002\u7576\u77E5\u662F\u4EBA\u3002\u6210\u5C31\u6700\u4E0A\u7B2C\u58F9\u5E0C\u6709\u4E4B\u6CD5\u3002\u82E5\u662F\u7D93\u5178\u6240\u5728\u4E4B\u8655\u3002\u5373\u70BA\u6709\u4F5B\u3002\u82E5\u5C0A\u91CD\u5F1F\u5B50\u3002\n\n\u723E\u6642\u3002\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u7576\u4F55\u540D\u6B64\u7D93\u3002\u6211\u7B49\u96F2\u4F55\u5949\u6301\u3002\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u662F\u7D93\u540D\u70BA\u91D1\u525B\u822C\u82E5\u6CE2\u7F85\u871C\u3002\u4EE5\u662F\u540D\u5B57\u3002\u6C5D\u7576\u5949\u6301\u3002\u6240\u4EE5\u8005\u4F55\u3002\u9808\u83E9\u63D0\u3002\u4F5B\u8AAA\u822C\u82E5\u6CE2\u7F85\u871C\u3002\u5373\u975E\u822C\u82E5\u6CE2\u7F85\u871C\u3002\u662F\u540D\u822C\u82E5\u6CE2\u7F85\u871C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6709\u6240\u8AAA\u6CD5\u4E0D\u3002\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u7121\u6240\u8AAA\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u4E09\u5343\u5927\u5343\u4E16\u754C\u6240\u6709\u5FAE\u5875\u3002\u662F\u70BA\u591A\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u751A\u591A\u3002\u4E16\u5C0A\u3002\u9808\u83E9\u63D0\u3002\u8AF8\u5FAE\u5875\u3002\u5982\u4F86\u8AAA\u975E\u5FAE\u5875\u3002\u662F\u540D\u5FAE\u5875\u3002\u5982\u4F86\u8AAA\u4E16\u754C\u3002\u5373\u975E\u4E16\u754C\u3002\u662F\u540D\u4E16\u754C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u53EF\u4EE5\u4E09\u5341\u4E8C\u76F8\u898B\u5982\u4F86\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u4E0D\u53EF\u4EE5\u4E09\u5341\u4E8C\u76F8\u5F97\u898B\u5982\u4F86\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8AAA\u4E09\u5341\u4E8C\u76F8\u3002\u5373\u662F\u975E\u76F8\u3002\u662F\u540D\u4E09\u5341\u4E8C\u76F8\u3002\u9808\u83E9\u63D0\u3002\u82E5\u6709\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u4EE5\u6052\u6CB3\u6C99\u7B49\u8EAB\u547D\u5E03\u65BD\u3002\u82E5\u5FA9\u6709\u4EBA\u3002\u65BC\u6B64\u7D93\u4E2D\u3002\u4E43\u81F3\u53D7\u6301\u56DB\u53E5\u5048\u7B49\u3002\u70BA\u4ED6\u4EBA\u8AAA\u3002\u5176\u798F\u751A\u591A\u3002\n\n\u723E\u6642\u9808\u83E9\u63D0\u3002\u805E\u8AAA\u662F\u7D93\u3002\u6DF1\u89E3\u7FA9\u8DA3\u3002\u6D95\u6DDA\u60B2\u6CE3\u3002\u800C\u767D\u4F5B\u8A00\u3002\u5E0C\u6709\u4E16\u5C0A\u3002\u4F5B\u8AAA\u5982\u662F\u751A\u6DF1\u7D93\u5178\u3002\u6211\u5F9E\u6614\u4F86\u6240\u5F97\u6167\u773C\u3002\u672A\u66FE\u5F97\u805E\u5982\u662F\u4E4B\u7D93\u3002\u4E16\u5C0A\u3002\u82E5\u5FA9\u6709\u4EBA\u5F97\u805E\u662F\u7D93\u3002\u4FE1\u5FC3\u6E05\u51C8\u3002\u5247\u751F\u5BE6\u76F8\u3002\u7576\u77E5\u662F\u4EBA\u3002\u6210\u5C31\u7B2C\u58F9\u5E0C\u6709\u529F\u5FB7\u3002\u4E16\u5C0A\u3002\u662F\u5BE6\u76F8\u8005\u3002\u5373\u662F\u975E\u76F8\u3002\u662F\u6545\u5982\u4F86\u8AAA\u540D\u5BE6\u76F8\u3002\u4E16\u5C0A\u3002\u6211\u4ECA\u5F97\u805E\u5982\u662F\u7D93\u5178\u3002\u4FE1\u89E3\u53D7\u6301\u3002\u4E0D\u8DB3\u70BA\u96E3\u3002\u82E5\u7576\u4F86\u4E16\u3002\u5F8C\u4E94\u767E\u6B72\u3002\u5176\u6709\u773E\u751F\u3002\u5F97\u805E\u662F\u7D93\u3002\u4FE1\u89E3\u53D7\u6301\u3002\u662F\u4EBA\u5373\u70BA\u7B2C\u58F9\u5E0C\u6709\u3002\n\n\u4F55\u4EE5\u6545\u3002\u6B64\u4EBA\u7121\u6211\u76F8\u3002\u7121\u4EBA\u76F8\u3002\u7121\u773E\u751F\u76F8\u3002\u7121\u58FD\u8005\u76F8\u3002\u6240\u4EE5\u8005\u4F55\u3002\u6211\u76F8\u5373\u662F\u975E\u76F8\u3002\u4EBA\u76F8\u773E\u751F\u76F8\u58FD\u8005\u76F8\u5373\u662F\u975E\u76F8\u3002\u4F55\u4EE5\u6545\u3002\u96E2\u58F9\u5207\u8AF8\u76F8\u3002\u5373\u540D\u8AF8\u4F5B\u3002\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u5982\u662F\u5982\u662F\u3002\u82E5\u5FA9\u6709\u4EBA\u3002\u5F97\u805E\u662F\u7D93\u3002\u4E0D\u9A5A\u4E0D\u6016\u4E0D\u754F\u3002\u7576\u77E5\u662F\u4EBA\u751A\u70BA\u5E0C\u6709\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u5982\u4F86\u8AAA\u7B2C\u58F9\u6CE2\u7F85\u871C\u3002\u5373\u975E\u7B2C\u58F9\u6CE2\u7F85\u871C\u3002\u662F\u540D\u7B2C\u58F9\u6CE2\u7F85\u871C\u3002\u9808\u83E9\u63D0\u3002\u5FCD\u8FB1\u6CE2\u7F85\u871C\u3002\u5982\u4F86\u8AAA\u975E\u5FCD\u8FB1\u6CE2\u7F85\u871C\u3002\u662F\u540D\u5FCD\u8FB1\u6CE2\u7F85\u871C\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\uFF01\u5982\u6211\u6614\u70BA\u6B4C\u5229\u738B\u5272\u622A\u8EAB\u9AD4\u3002\u6211\u65BC\u723E\u6642\u3002\u7121\u6211\u76F8\u3002\u7121\u4EBA\u76F8\u3002\u7121\u773E\u751F\u76F8\u3002\u7121\u58FD\u8005\u76F8\u3002\u4F55\u4EE5\u6545\u3002\u6211\u65BC\u5F80\u6614\u7BC0\u7BC0\u652F\u89E3\u6642\u3002\u82E5\u6709\u6211\u76F8\u4EBA\u76F8\u773E\u751F\u76F8\u58FD\u8005\u76F8\u3002\u61C9\u751F\u55D4\u6068\u3002\u9808\u83E9\u63D0\u3002\u53C8\u5FF5\u904E\u53BB\u65BC\u4E94\u767E\u4E16\u4F5C\u5FCD\u8FB1\u4ED9\u4EBA\u3002\u65BC\u723E\u6240\u4E16\u3002\u7121\u6211\u76F8\u3002\u7121\u4EBA\u76F8\u3002\u7121\u773E\u751F\u76F8\u3002\u7121\u58FD\u8005\u76F8\u3002\u662F\u6545\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u61C9\u96E2\u58F9\u5207\u76F8\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u3002\u4E0D\u61C9\u4F4F\u8272\u751F\u5FC3\u3002\u4E0D\u61C9\u4F4F\u8072\u9999\u5473\u89F8\u6CD5\u751F\u5FC3\u3002\u61C9\u751F\u7121\u6240\u4F4F\u5FC3\u3002\u82E5\u5FC3\u6709\u4F4F\u5373\u70BA\u975E\u4F4F\uFF0C\u662F\u6545\u4F5B\u8AAA\u83E9\u85A9\u5FC3\u4E0D\u61C9\u4F4F\u8272\u5E03\u65BD\u3002\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u70BA\u5229\u76CA\u58F9\u5207\u773E\u751F\u6545\u3002\u61C9\u5982\u662F\u5E03\u65BD\u3002\u5982\u4F86\u8AAA\u58F9\u5207\u8AF8\u76F8\u3002\u5373\u662F\u975E\u76F8\u3002\u53C8\u8AAA\u58F9\u5207\u773E\u751F\u3002\u5373\u975E\u773E\u751F\u3002\u9808\u83E9\u63D0\u3002\u5982\u4F86\u662F\u771F\u8A9E\u8005\u3002\u5BE6\u8A9E\u8005\u3002\u5982\u8A9E\u8005\u3002\u4E0D\u8A91\u8A9E\u8005\u3002\u4E0D\u7570\u8A9E\u8005\u3002\u9808\u83E9\u63D0\u3002\u5982\u4F86\u6240\u5F97\u6CD5\u3002\u6B64\u6CD5\u7121\u5BE6\u7121\u865B\u3002\u9808\u83E9\u63D0\u3002\u82E5\u83E9\u85A9\u5FC3\u3002\u4F4F\u65BC\u6CD5\u800C\u884C\u5E03\u65BD\u3002\u5982\u4EBA\u5165\u6697\uFF0C\u5373\u7121\u6240\u898B\u3002\u82E5\u83E9\u85A9\u5FC3\u4E0D\u4F4F\u6CD5\u800C\u884C\u5E03\u65BD\u3002\u5982\u4EBA\u6709\u76EE\u3002\u65E5\u5149\u660E\u7167\u3002\u898B\u7A2E\u7A2E\u8272\u3002\u9808\u83E9\u63D0\u3002\u7576\u4F86\u4E4B\u4E16\u3002\u82E5\u6709\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u80FD\u65BC\u6B64\u7D93\u53D7\u6301\u8B80\u8AA6\u3002\u5373\u70BA\u5982\u4F86\u3002\u4EE5\u4F5B\u667A\u6167\u3002\u6089\u77E5\u662F\u4EBA\u3002\u6089\u898B\u662F\u4EBA\u3002\u7686\u5F97\u6210\u5C31\u7121\u91CF\u7121\u908A\u529F\u5FB7\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u6709\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u521D\u65E5\u5206\u3002\u4EE5\u6052\u6CB3\u6C99\u7B49\u8EAB\u5E03\u65BD\u3002\u4E2D\u65E5\u5206\u3002\u5FA9\u4EE5\u6052\u6CB3\u6C99\u7B49\u8EAB\u5E03\u65BD\u3002\u5F8C\u65E5\u5206\u3002\u4EA6\u4EE5\u6052\u6CB3\u6C99\u7B49\u8EAB\u5E03\u65BD\u3002\u5982\u662F\u7121\u91CF\u767E\u5343\u842C\u5104\u52AB\u3002\u4EE5\u8EAB\u5E03\u65BD\u3002\u82E5\u5FA9\u6709\u4EBA\uFF0C\u805E\u6B64\u7D93\u5178\u3002\u4FE1\u5FC3\u4E0D\u9006\u3002\u5176\u798F\u52DD\u5F7C\u3002\u4F55\u6CC1\u66F8\u5BEB\u53D7\u6301\u8B80\u8AA6\u3002\u70BA\u4EBA\u89E3\u8AAA\u3002\u9808\u83E9\u63D0\u3002\u4EE5\u8981\u8A00\u4E4B\u3002\u662F\u7D93\u6709\u4E0D\u53EF\u601D\u8B70\u3002\u4E0D\u53EF\u7A31\u91CF\u3002\u7121\u908A\u529F\u5FB7\u3002\u5982\u4F86\u70BA\u767C\u5927\u4E58\u8005\u8AAA\u3002\u70BA\u767C\u6700\u4E0A\u4E58\u8005\u8AAA\u3002\u82E5\u6709\u4EBA\u80FD\u53D7\u6301\u8B80\u8AA6\u3002\u5EE3\u70BA\u4EBA\u8AAA\u3002\u5982\u4F86\u6089\u77E5\u662F\u4EBA\u3002\u6089\u898B\u662F\u4EBA\u3002\u7686\u5F97\u6210\u5C31\u4E0D\u53EF\u91CF\u3002\u4E0D\u53EF\u7A31\u3002\u7121\u6709\u908A\u3002\u4E0D\u53EF\u601D\u8B70\u529F\u5FB7\u3002\u5982\u662F\u4EBA\u7B49\u3002\u5373\u70BA\u8377\u64D4\u5982\u4F86\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u82E5\u6A02\u5C0F\u6CD5\u8005\u3002\u8457\u6211\u898B\u4EBA\u898B\u773E\u751F\u898B\u58FD\u8005\u898B\u3002\u5373\u65BC\u6B64\u7D93\u3002\u4E0D\u80FD\u807D\u53D7\u8B80\u8AA6\u3002\u70BA\u4EBA\u89E3\u8AAA\u3002\u9808\u83E9\u63D0\u3002\u5728\u5728\u8655\u8655\u3002\u82E5\u6709\u6B64\u7D93\u3002\u58F9\u5207\u4E16\u9593\u5929\u4EBA\u963F\u4FEE\u7F85\u3002\u6240\u61C9\u4F9B\u990A\u3002\u7576\u77E5\u6B64\u8655\u3002\u5373\u70BA\u662F\u5854\u3002\u7686\u61C9\u606D\u656C\u3002\u4F5C\u79AE\u570D\u7E5E\u3002\u4EE5\u8AF8\u83EF\u9999\u800C\u6563\u5176\u8655\u3002\n\n\u5FA9\u6B21\u3002\u9808\u83E9\u63D0\u3002\u82E5\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u53D7\u6301\u8B80\u8AA6\u6B64\u7D93\u3002\u82E5\u70BA\u4EBA\u8F15\u8CE4\u3002\u662F\u4EBA\u5148\u4E16\u7F6A\u696D\u3002\u61C9\u58AE\u60E1\u9053\u3002\u4EE5\u4ECA\u4E16\u4EBA\u8F15\u8CE4\u6545\u3002\u5148\u4E16\u7F6A\u696D\u5373\u70BA\u6D88\u6EC5\u3002\u7576\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u6211\u5FF5\u904E\u53BB\u7121\u91CF\u963F\u50E7\u7957\u52AB\u3002\u65BC\u7136\u71C8\u4F5B\u524D\u3002\u5F97\u503C\u516B\u767E\u56DB\u5343\u842C\u5104\u90A3\u7531\u4ED6\u8AF8\u4F5B\u3002\u6089\u7686\u4F9B\u990A\u627F\u4E8B\u3002\u7121\u7A7A\u904E\u8005\u3002\u82E5\u5FA9\u6709\u4EBA\u3002\u65BC\u5F8C\u672B\u4E16\u3002\u80FD\u53D7\u6301\u8B80\u8AA6\u6B64\u7D93\u3002\u6240\u5F97\u529F\u5FB7\u3002\u65BC\u6211\u6240\u4F9B\u990A\u8AF8\u4F5B\u529F\u5FB7\u3002\u767E\u5206\u4E0D\u53CA\u58F9\u3002\u5343\u842C\u5104\u5206\u4E43\u81F3\u7B97\u6578\u8B6C\u55BB\u6240\u4E0D\u80FD\u53CA\u3002\u9808\u83E9\u63D0\u3002\u82E5\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u65BC\u5F8C\u672B\u4E16\u3002\u6709\u53D7\u6301\u8B80\u8AA6\u6B64\u7D93\u3002\u6240\u5F97\u529F\u5FB7\u3002\u6211\u82E5\u5177\u8AAA\u8005\u3002\u6216\u6709\u4EBA\u805E\u3002\u5FC3\u5373\u72C2\u4E82\u3002\u72D0\u7591\u4E0D\u4FE1\u3002\u9808\u83E9\u63D0\u3002\u7576\u77E5\u662F\u7D93\u7FA9\u4E0D\u53EF\u601D\u8B70\u3002\u679C\u5831\u4EA6\u4E0D\u53EF\u601D\u8B70\u3002\n\n\u723E\u6642\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u3002\u96F2\u4F55\u61C9\u4F4F\uFF1F\u96F2\u4F55\u964D\u4F0F\u5176\u5FC3\uFF1F\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u8005\u3002\u7576\u751F\u5982\u662F\u5FC3\u3002\u6211\u61C9\u6EC5\u5EA6\u58F9\u5207\u773E\u751F\u3002\u6EC5\u5EA6\u58F9\u5207\u773E\u751F\u5DF2\u3002\u800C\u7121\u6709\u58F9\u773E\u751F\u5BE6\u6EC5\u5EA6\u8005\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u82E5\u83E9\u85A9\u6709\u6211\u76F8\u4EBA\u76F8\u773E\u751F\u76F8\u58FD\u8005\u76F8\uFF0C\u5373\u975E\u83E9\u85A9\u3002\u6240\u4EE5\u8005\u4F55\u3002\u9808\u83E9\u63D0\u3002\u5BE6\u7121\u6709\u6CD5\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u8005\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u65BC\u7136\u71C8\u4F5B\u6240\u3002\u6709\u6CD5\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u5982\u6211\u89E3\u4F5B\u6240\u8AAA\u7FA9\u3002\u4F5B\u65BC\u7136\u71C8\u4F5B\u6240\u3002\u7121\u6709\u6CD5\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u4F5B\u8A00\u3002\u5982\u662F\u5982\u662F\u3002\u9808\u83E9\u63D0\u3002\u5BE6\u7121\u6709\u6CD5\u5982\u4F86\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u82E5\u6709\u6CD5\u5982\u4F86\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u8005\u3002\u7136\u71C8\u4F5B\u5247\u4E0D\u8207\u6211\u6388\u8A18\u3002\u6C5D\u65BC\u4F86\u4E16\u3002\u7576\u5F97\u4F5C\u4F5B\u3002\u865F\u91CB\u8FE6\u725F\u5C3C\u3002\u4EE5\u5BE6\u7121\u6709\u6CD5\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u662F\u6545\u7136\u71C8\u4F5B\u8207\u6211\u6388\u8A18\u3002\u4F5C\u662F\u8A00\u3002\u6C5D\u65BC\u4F86\u4E16\u3002\u7576\u5F97\u4F5C\u4F5B\u3002\u865F\u91CB\u8FE6\u725F\u5C3C\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8005\u3002\u5373\u8AF8\u6CD5\u5982\u7FA9\u3002\u82E5\u6709\u4EBA\u8A00\u3002\u5982\u4F86\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u5BE6\u7121\u6709\u6CD5\u3002\u4F5B\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u5982\u4F86\u6240\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u65BC\u662F\u4E2D\u7121\u5BE6\u7121\u865B\u3002\u662F\u6545\u5982\u4F86\u8AAA\u58F9\u5207\u6CD5\u7686\u662F\u4F5B\u6CD5\u3002\u9808\u83E9\u63D0\u3002\u6240\u8A00\u58F9\u5207\u6CD5\u8005\u3002\u5373\u975E\u58F9\u5207\u6CD5\u3002\u662F\u6545\u540D\u58F9\u5207\u6CD5\u3002\u9808\u83E9\u63D0\u3002\u8B6C\u5982\u4EBA\u8EAB\u9577\u5927\u3002\u9808\u83E9\u63D0\u8A00\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u8AAA\u4EBA\u8EAB\u9577\u5927\u3002\u5373\u70BA\u975E\u5927\u8EAB\u3002\u662F\u540D\u5927\u8EAB\u3002\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u4EA6\u5982\u662F\u3002\u82E5\u4F5C\u662F\u8A00\u3002\u6211\u7576\u6EC5\u5EA6\u7121\u91CF\u773E\u751F\u3002\u5373\u4E0D\u540D\u83E9\u85A9\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u5BE6\u7121\u6709\u6CD5\u540D\u70BA\u83E9\u85A9\u3002\u662F\u6545\u4F5B\u8AAA\u3002\u58F9\u5207\u6CD5\u7121\u6211\u7121\u4EBA\u7121\u773E\u751F\u7121\u58FD\u8005\u3002\u9808\u83E9\u63D0\u3002\u82E5\u83E9\u85A9\u4F5C\u662F\u8A00\u3002\u6211\u7576\u838A\u56B4\u4F5B\u571F\u3002\u662F\u4E0D\u540D\u83E9\u85A9\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8AAA\u838A\u56B4\u4F5B\u571F\u8005\u3002\u5373\u975E\u838A\u56B4\u3002\u662F\u540D\u838A\u56B4\u3002\u9808\u83E9\u63D0\u3002\u82E5\u83E9\u85A9\u901A\u9054\u7121\u6211\u6CD5\u8005\u3002\u5982\u4F86\u8AAA\u540D\u771F\u662F\u83E9\u85A9\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6709\u8089\u773C\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u6709\u8089\u773C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6709\u5929\u773C\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u6709\u5929\u773C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6709\u6167\u773C\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u6709\u6167\u773C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6709\u6CD5\u773C\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u6709\u6CD5\u773C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u6709\u4F5B\u773C\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u6709\u4F5B\u773C\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u6052\u6CB3\u4E2D\u6240\u6709\u6C99\u3002\u4F5B\u8AAA\u662F\u6C99\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u8AAA\u662F\u6C99\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u58F9\u6052\u6CB3\u4E2D\u6240\u6709\u6C99\u3002\u6709\u5982\u662F\u6C99\u7B49\u6052\u6CB3\u3002\u662F\u8AF8\u6052\u6CB3\u6240\u6709\u6C99\u6578\u4F5B\u4E16\u754C\uFF0C\u5982\u662F\u5BE7\u70BA\u591A\u4E0D\u3002\u751A\u591A\u3002\u4E16\u5C0A\u3002\u4F5B\u544A\u9808\u83E9\u63D0\u3002\u723E\u6240\u570B\u571F\u4E2D\u3002\u6240\u6709\u773E\u751F\uFF0C\u82E5\u5E79\u7A2E\u5FC3\u3002\u5982\u4F86\u6089\u77E5\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8AAA\u8AF8\u5FC3\u7686\u70BA\u975E\u5FC3\u3002\u662F\u540D\u70BA\u5FC3\u3002\u6240\u4EE5\u8005\u4F55\u3002\u9808\u83E9\u63D0\u3002\u904E\u53BB\u5FC3\u4E0D\u53EF\u5F97\u3002\u73FE\u5728\u5FC3\u4E0D\u53EF\u5F97\u3002\u672A\u4F86\u5FC3\u4E0D\u53EF\u5F97\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u82E5\u6709\u4EBA\u6EFF\u4E09\u5343\u5927\u5343\u4E16\u754C\u4E03\u5BF6\u3002\u4EE5\u7528\u5E03\u65BD\u3002\u662F\u4EBA\u4EE5\u662F\u56E0\u7DE3\u3002\u5F97\u798F\u591A\u4E0D\u3002\u5982\u662F\u3002\u4E16\u5C0A\u3002\u6B64\u4EBA\u4EE5\u662F\u56E0\u7DE3\u3002\u5F97\u798F\u751A\u591A\u3002\u9808\u83E9\u63D0\u3002\u82E5\u798F\u5FB7\u6709\u5BE6\u3002\u5982\u4F86\u4E0D\u8AAA\u5F97\u798F\u5FB7\u591A\u3002\u4EE5\u798F\u5FB7\u7121\u6545\u3002\u5982\u4F86\u8AAA\u5F97\u798F\u5FB7\u591A\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u4F5B\u53EF\u4EE5\u5177\u8DB3\u8272\u8EAB\u898B\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u4E0D\u61C9\u4EE5\u5177\u8DB3\u8272\u8EAB\u898B\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8AAA\u3002\u5177\u8DB3\u8272\u8EAB\u3002\u5373\u975E\u5177\u8DB3\u8272\u8EAB\u3002\u662F\u540D\u5177\u8DB3\u8272\u8EAB\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u5982\u4F86\u53EF\u4EE5\u5177\u8DB3\u8AF8\u76F8\u898B\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u4E0D\u61C9\u4EE5\u5177\u8DB3\u8AF8\u76F8\u898B\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8AAA\u8AF8\u76F8\u5177\u8DB3\u3002\u5373\u975E\u5177\u8DB3\u3002\u662F\u540D\u8AF8\u76F8\u5177\u8DB3\u3002\n\n\u9808\u83E9\u63D0\u3002\u6C5D\u52FF\u8B02\u5982\u4F86\u4F5C\u662F\u5FF5\u3002\u6211\u7576\u6709\u6240\u8AAA\u6CD5\u3002\u83AB\u4F5C\u662F\u5FF5\u3002\u4F55\u4EE5\u6545\u3002\u82E5\u4EBA\u8A00\u5982\u4F86\u6709\u6240\u8AAA\u6CD5\u3002\u5373\u70BA\u8B17\u4F5B\u3002\u4E0D\u80FD\u89E3\u6211\u6240\u8AAA\u6545\u3002\u9808\u83E9\u63D0\u3002\u8AAA\u6CD5\u8005\u3002\u7121\u6CD5\u53EF\u8AAA\u3002\u662F\u540D\u8AAA\u6CD5\u3002\u723E\u6642\u6167\u547D\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u9817\u6709\u773E\u751F\u3002\u65BC\u672A\u4F86\u4E16\u3002\u805E\u8AAA\u662F\u6CD5\u3002\u751F\u4FE1\u5FC3\u4E0D\u3002\u4F5B\u8A00\u3002\u9808\u83E9\u63D0\u3002\u5F7C\u975E\u773E\u751F\u3002\u975E\u4E0D\u773E\u751F\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u773E\u751F\u773E\u751F\u8005\u3002\u5982\u4F86\u8AAA\u975E\u773E\u751F\u3002\u662F\u540D\u773E\u751F\u3002\n\n\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u4F5B\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u70BA\u7121\u6240\u5F97\u8036\u3002\u4F5B\u8A00\u3002\u5982\u662F\u3002\u5982\u662F\u3002\u9808\u83E9\u63D0\u3002\u6211\u65BC\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u4E43\u81F3\u7121\u6709\u5C11\u6CD5\u53EF\u5F97\u3002\u662F\u540D\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\n\n\u5FA9\u6B21\u3002\u9808\u83E9\u63D0\u3002\u662F\u6CD5\u5E73\u7B49\u3002\u7121\u6709\u9AD8\u4E0B\u3002\u662F\u540D\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u4EE5\u7121\u6211\u7121\u4EBA\u7121\u773E\u751F\u7121\u58FD\u8005\u3002\u4FEE\u58F9\u5207\u5584\u6CD5\u3002\u5373\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u6240\u8A00\u5584\u6CD5\u8005\u3002\u5982\u4F86\u8AAA\u5373\u975E\u5584\u6CD5\u3002\u662F\u540D\u5584\u6CD5\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u4E09\u5343\u5927\u5343\u4E16\u754C\u4E2D\u3002\u6240\u6709\u8AF8\u9808\u5F4C\u5C71\u738B\u3002\u5982\u662F\u7B49\u4E03\u5BF6\u805A\u3002\u6709\u4EBA\u6301\u7528\u5E03\u65BD\u3002\u82E5\u4EBA\u4EE5\u6B64\u822C\u82E5\u6CE2\u7F85\u871C\u7D93\u3002\u4E43\u81F3\u56DB\u53E5\u5048\u7B49\u3002\u53D7\u6301\u8B80\u8AA6\u3002\u70BA\u4ED6\u4EBA\u8AAA\u3002\u65BC\u524D\u798F\u5FB7\u3002\u767E\u5206\u4E0D\u53CA\u58F9\u3002\u767E\u5343\u842C\u5104\u5206\u3002\u4E43\u81F3\u7B97\u6578\u8B6C\u55BB\u6240\u4E0D\u80FD\u53CA\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u6C5D\u7B49\u52FF\u8B02\u5982\u4F86\u4F5C\u662F\u5FF5\u3002\u6211\u7576\u5EA6\u773E\u751F\u3002\u9808\u83E9\u63D0\u3002\u83AB\u4F5C\u662F\u5FF5\u3002\u4F55\u4EE5\u6545\u3002\u5BE6\u7121\u6709\u773E\u751F\u5982\u4F86\u5EA6\u8005\u3002\u82E5\u6709\u773E\u751F\u5982\u4F86\u5EA6\u8005\u3002\u5982\u4F86\u5373\u6709\u6211\u4EBA\u773E\u751F\u58FD\u8005\u3002\u9808\u83E9\u63D0\u3002\u5982\u4F86\u8AAA\u6709\u6211\u8005\u3002\u5373\u975E\u6709\u6211\u3002\u800C\u51E1\u592B\u4E4B\u4EBA\u4EE5\u70BA\u6709\u6211\u3002\u9808\u83E9\u63D0\u3002\u51E1\u592B\u8005\u3002\u5982\u4F86\u8AAA\u5373\u975E\u51E1\u592B\u3002\u662F\u540D\u51E1\u592B\u3002\n\n\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u53EF\u4EE5\u4E09\u5341\u4E8C\u76F8\u89C0\u5982\u4F86\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u5982\u662F\u5982\u662F\u4EE5\u4E09\u5341\u4E8C\u76F8\u89C0\u5982\u4F86\u3002\u4F5B\u8A00\u3002\u9808\u83E9\u63D0\u3002\u82E5\u4EE5\u4E09\u5341\u4E8C\u76F8\u89C0\u5982\u4F86\u8005\u3002\u8F49\u8F2A\u8056\u738B\u5373\u662F\u5982\u4F86\u3002\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u5982\u6211\u89E3\u4F5B\u6240\u8AAA\u7FA9\u3002\u4E0D\u61C9\u4EE5\u4E09\u5341\u4E8C\u76F8\u89C0\u5982\u4F86\u3002\u723E\u6642\u3002\u4E16\u5C0A\u800C\u8AAA\u5048\u8A00\u3002\u82E5\u4EE5\u8272\u898B\u6211\u3002\u4EE5\u97F3\u8072\u6C42\u6211\u3002\u662F\u4EBA\u884C\u90AA\u9053\u3002\u4E0D\u80FD\u898B\u5982\u4F86\u3002\n\n\u9808\u83E9\u63D0\u3002\u6C5D\u82E5\u4F5C\u662F\u5FF5\u3002\u5982\u4F86\u4E0D\u4EE5\u5177\u8DB3\u76F8\u6545\u3002\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u83AB\u4F5C\u662F\u5FF5\u3002\u5982\u4F86\u4E0D\u4EE5\u5177\u8DB3\u76F8\u6545\u3002\u5F97\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u3002\u9808\u83E9\u63D0\u3002\u6C5D\u82E5\u4F5C\u662F\u5FF5\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u8005\u3002\u8AAA\u8AF8\u6CD5\u65B7\u6EC5\u3002\u83AB\u4F5C\u662F\u5FF5\u3002\u4F55\u4EE5\u6545\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u8005\u3002\u65BC\u6CD5\u4E0D\u8AAA\u65B7\u6EC5\u76F8\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u83E9\u85A9\u4EE5\u6EFF\u6052\u6CB3\u6C99\u7B49\u4E16\u754C\u4E03\u5BF6\u3002\u6301\u7528\u5E03\u65BD\u3002\u82E5\u5FA9\u6709\u4EBA\u77E5\u58F9\u5207\u6CD5\u7121\u6211\u3002\u5F97\u6210\u65BC\u5FCD\u3002\u6B64\u83E9\u85A9\u52DD\u524D\u83E9\u85A9\u6240\u5F97\u529F\u5FB7\u3002\u4F55\u4EE5\u6545\u3002\u9808\u83E9\u63D0\u3002\u4EE5\u8AF8\u83E9\u85A9\u4E0D\u53D7\u798F\u5FB7\u6545\u3002\u9808\u83E9\u63D0\u767D\u4F5B\u8A00\u3002\u4E16\u5C0A\u3002\u96F2\u4F55\u83E9\u85A9\u4E0D\u53D7\u798F\u5FB7\u3002\u9808\u83E9\u63D0\u3002\u83E9\u85A9\u6240\u4F5C\u798F\u5FB7\u3002\u4E0D\u61C9\u8CAA\u8457\u3002\u662F\u6545\u8AAA\u4E0D\u53D7\u798F\u5FB7\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u6709\u4EBA\u8A00\u3002\u5982\u4F86\u82E5\u4F86\u82E5\u53BB\u3002\u82E5\u5750\u82E5\u81E5\u3002\u662F\u4EBA\u4E0D\u89E3\u6211\u6240\u8AAA\u7FA9\u3002\u4F55\u4EE5\u6545\u3002\u5982\u4F86\u8005\u3002\u7121\u6240\u5F9E\u4F86\u3002\u4EA6\u7121\u6240\u53BB\u3002\u6545\u540D\u5982\u4F86\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u3002\u4EE5\u4E09\u5343\u5927\u5343\u4E16\u754C\u788E\u70BA\u5FAE\u5875\u3002\u65BC\u610F\u96F2\u4F55\u3002\u662F\u5FAE\u5875\u773E\u5BE7\u70BA\u591A\u4E0D\u3002\u9808\u83E9\u63D0\u8A00\u3002\u751A\u591A\u3002\u4E16\u5C0A\u3002\u4F55\u4EE5\u6545\u3002\u82E5\u662F\u5FAE\u5875\u773E\u5BE6\u6709\u8005\u3002\u4F5B\u5373\u4E0D\u8AAA\u662F\u5FAE\u5875\u773E\u3002\u6240\u4EE5\u8005\u4F55\u3002\u4F5B\u8AAA\u3002\u5FAE\u5875\u773E\u3002\u5373\u975E\u5FAE\u5875\u773E\u3002\u662F\u540D\u5FAE\u5875\u773E\u3002\u4E16\u5C0A\u3002\u5982\u4F86\u6240\u8AAA\u4E09\u5343\u5927\u5343\u4E16\u754C\u3002\u5373\u975E\u4E16\u754C\u3002\u662F\u540D\u4E16\u754C\u3002\u4F55\u4EE5\u6545\u3002\u82E5\u4E16\u754C\u5BE6\u6709\u8005\u3002\u5373\u662F\u58F9\u5408\u76F8\u3002\u5982\u4F86\u8AAA\u3002\u58F9\u5408\u76F8\u3002\u5373\u975E\u58F9\u5408\u76F8\u3002\u662F\u540D\u58F9\u5408\u76F8\u3002\u9808\u83E9\u63D0\u3002\u58F9\u5408\u76F8\u8005\u3002\u5373\u662F\u4E0D\u53EF\u8AAA\u3002\u4F46\u51E1\u592B\u4E4B\u4EBA\u8CAA\u8457\u5176\u4E8B\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u4EBA\u8A00\u3002\u4F5B\u8AAA\u6211\u898B\u4EBA\u898B\u773E\u751F\u898B\u58FD\u8005\u898B\u3002\u9808\u83E9\u63D0\u3002\u65BC\u610F\u96F2\u4F55\u3002\u662F\u4EBA\u89E3\u6211\u6240\u8AAA\u7FA9\u4E0D\u3002\u4E0D\u4E5F\u3002\u4E16\u5C0A\u3002\u662F\u4EBA\u4E0D\u89E3\u5982\u4F86\u6240\u8AAA\u7FA9\u3002\u4F55\u4EE5\u6545\u3002\u4E16\u5C0A\u8AAA\u3002\u6211\u898B\u4EBA\u898B\u773E\u751F\u898B\u58FD\u8005\u898B\uFF0C\u5373\u975E\u6211\u898B\u4EBA\u898B\u773E\u751F\u898B\u58FD\u8005\u898B\uFF0C\u662F\u540D\u6211\u898B\u4EBA\u898B\u773E\u751F\u898B\u58FD\u8005\u898B\u3002\u9808\u83E9\u63D0\u3002\u767C\u963F\u8028\u591A\u7F85\u4E09\u85D0\u4E09\u83E9\u63D0\u5FC3\u8005\u3002\u65BC\u58F9\u5207\u6CD5\u3002\u61C9\u5982\u662F\u77E5\u3002\u5982\u662F\u898B\u3002\u5982\u662F\u4FE1\u89E3\u3002\u4E0D\u751F\u6CD5\u76F8\u3002\u9808\u83E9\u63D0\u3002\u6240\u8A00\u6CD5\u76F8\u8005\u3002\u5982\u4F86\u8AAA\u5373\u975E\u6CD5\u76F8\u3002\u662F\u540D\u6CD5\u76F8\u3002\n\n\u9808\u83E9\u63D0\u3002\u82E5\u6709\u4EBA\u4EE5\u6EFF\u7121\u91CF\u963F\u50E7\u7957\u4E16\u754C\u4E03\u5BF6\u6301\u7528\u5E03\u65BD\u3002\u82E5\u6709\u5584\u7537\u5B50\u3002\u5584\u5973\u4EBA\u767C\u83E9\u63D0\u5FC3\u8005\u3002\u6301\u65BC\u6B64\u7D93\u3002\u4E43\u81F3\u56DB\u53E5\u5048\u7B49\u3002\u53D7\u6301\u8B80\u8AA6\u3002\u70BA\u4EBA\u6F14\u8AAA\u3002\u5176\u798F\u52DD\u5F7C\u3002\u96F2\u4F55\u70BA\u4EBA\u6F14\u8AAA\u3002\u4E0D\u53D6\u65BC\u76F8\u3002\u5982\u5982\u4E0D\u52D5\u3002\u4F55\u4EE5\u6545\u3002\u58F9\u5207\u6709\u70BA\u6CD5\u3002\u5982\u5922\u5E7B\u6CE1\u5F71\u3002\u5982\u9732\u4EA6\u5982\u96FB\u3002\u61C9\u4F5C\u5982\u662F\u89C0\u3002\u4F5B\u8AAA\u662F\u7D93\u5DF2\u3002\u9577\u8001\u9808\u83E9\u63D0\u3002\u53CA\u8AF8\u6BD4\u4E18\u3002\u6BD4\u4E18\u5C3C\u3002\u512A\u5A46\u585E\u3002\u512A\u5A46\u5937\u3002\u58F9\u5207\u4E16\u9593\u5929\u4EBA\u963F\u4FEE\u7F85\u3002\u805E\u4F5B\u6240\u8AAA\u3002\u7686\u5927\u6B61\u559C\u3002\u4FE1\u53D7\u5949\u884C\u3002\n";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _unit = __webpack_require__(1);

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit("key_down", true);
  if (store.state.cur !== null) {
    _event2.default.down({
      key: "down",
      begin: 40,
      interval: 40,
      callback: function callback(stopDownTrigger) {
        var state = store.state;
        if (state.lock) {
          return;
        }
        if (_music.music.move) {
          _music.music.move();
        }
        var cur = state.cur;
        if (cur === null) {
          return;
        }
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        var next = cur.fall();
        if ((0, _unit.want)(next, state.matrix)) {
          store.commit("moveBlock", next);

          _states2.default.auto();
        } else {
          var matrix = JSON.parse((0, _stringify2.default)(state.matrix));
          var shape = cur.shape;
          var xy = cur.xy;
          shape.forEach(function (m, k1) {
            return m.forEach(function (n, k2) {
              if (n && xy[0] + k1 >= 0) {
                var line = matrix[xy[0] + k1];
                line[xy[1] + k2] = 1;

                matrix[xy[0] + k1] = line;
              }
            });
          });
          _states2.default.nextAround(matrix, stopDownTrigger);
        }
      }
    });
  } else {
    _event2.default.down({
      key: "down",
      begin: 200,
      interval: 100,
      callback: function callback() {
        if (store.state.lock) {
          return;
        }
        var state = store.state;
        var cur = state.cur;
        if (cur) {
          return;
        }
        if (_music.music.move) {
          _music.music.move();
        }
        var startLines = state.startLines;
        startLines = startLines - 1 < 0 ? 10 : startLines - 1;
        store.commit("startLines", startLines);
      }
    });
  }
};

var up = function up(store) {
  store.commit("key_down", false);
  _event2.default.up({
    key: "down"
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

var _const = __webpack_require__(0);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_left', true);
  _event2.default.down({
    key: 'left',
    begin: 200,
    interval: 100,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      if (_music.music.move) {
        _music.music.move();
      }
      var cur = state.cur;
      if (cur !== null) {
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        var next = cur.left();
        var delay = _const.delays[state.speedRun - 1];
        var timeStamp = void 0;
        if ((0, _unit.want)(next, state.matrix)) {
          next.timeStamp += parseInt(delay, 10);
          store.commit('moveBlock', next);
          timeStamp = next.timeStamp;
        } else {
          cur.timeStamp += parseInt(parseInt(delay, 10) / 1.5, 10);
          store.commit('moveBlock', cur);
          timeStamp = cur.timeStamp;
        }
        var remain = _const.speeds[state.speedRun - 1] - (Date.now() - timeStamp);
        _states2.default.auto(remain);
      } else {
        var speed = state.speedStart;
        speed = speed - 1 < 1 ? 6 : speed - 1;
        store.commit('speedStart', speed);
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_left', false);
  _event2.default.up({
    key: 'left'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_pause', true);
  _event2.default.down({
    key: 'p',
    once: true,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      var cur = state.cur;
      var isPause = state.pause;
      if (cur !== null) {
        _states2.default.pause(!isPause);
      } else {
        _states2.default.start();
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_pause', false);
  _event2.default.up({
    key: 'p'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_reset', true);
  if (store.state.lock) {
    return;
  }
  if (store.state.cur !== null) {
    _event2.default.down({
      key: 'r',
      once: true,
      callback: function callback() {
        _states2.default.overStart();
      }
    });
  } else {
    _event2.default.down({
      key: 'r',
      once: true,
      callback: function callback() {
        if (store.state.lock) {
          return;
        }
        _states2.default.start();
      }
    });
  }
};

var up = function up(store) {
  store.commit('key_reset', false);
  _event2.default.up({
    key: 'r'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

var _const = __webpack_require__(0);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_right', true);
  _event2.default.down({
    key: 'right',
    begin: 200,
    interval: 100,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      if (_music.music.move) {
        _music.music.move();
      }
      var cur = state.cur;
      if (cur !== null) {
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        var next = cur.right();
        var delay = _const.delays[state.speedRun - 1];
        var timeStamp = void 0;
        if ((0, _unit.want)(next, state.matrix)) {
          next.timeStamp += parseInt(delay, 10);
          store.commit('moveBlock', next);
          timeStamp = next.timeStamp;
        } else {
          cur.timeStamp += parseInt(parseInt(delay, 10) / 1.5, 10);
          store.commit('moveBlock', cur);
          timeStamp = cur.timeStamp;
        }
        var remain = _const.speeds[state.speedRun - 1] - (Date.now() - timeStamp);
        _states2.default.auto(remain);
      } else {
        var speed = state.speedStart;
        speed = speed + 1 > 6 ? 1 : speed + 1;
        store.commit('speedStart', speed);
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_right', false);
  _event2.default.up({
    key: 'right'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_rotate', true);
  if (store.state.cur !== null) {
    _event2.default.down({
      key: 'rotate',
      once: true,
      callback: function callback() {
        var state = store.state;
        if (state.lock) {
          return;
        }
        if (state.pause) {
          _states2.default.pause(false);
        }
        var cur = state.cur;
        if (cur === null) {
          return;
        }
        if (_music.music.rotate) {
          _music.music.rotate();
        }
        var next = cur.rotate();
        if ((0, _unit.want)(next, state.matrix)) {
          store.commit('moveBlock', next);
        }
      }
    });
  } else {
    _event2.default.down({
      key: 'rotate',
      begin: 200,
      interval: 100,
      callback: function callback() {
        if (store.state.lock) {
          return;
        }
        if (_music.music.move) {
          _music.music.move();
        }
        var state = store.state;
        var cur = state.cur;
        if (cur) {
          return;
        }
        var startLines = state.startLines;
        startLines = startLines + 1 > 10 ? 0 : startLines + 1;
        store.commit('startLines', startLines);
      }
    });
  }
};

var up = function up(store) {
  store.commit('key_rotate', false);
  _event2.default.up({
    key: 'rotate'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_music', true);
  if (store.state.lock) {
    return;
  }
  _event2.default.down({
    key: 's',
    once: true,
    callback: function callback() {
      if (store.state.lock) {
        return;
      }
      store.commit('music', !store.state.music);
    }
  });
};

var up = function up(store) {
  store.commit('key_music', false);
  _event2.default.up({
    key: 's'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _unit = __webpack_require__(1);

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(5);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit("key_drop", true);
  _event2.default.down({
    key: "space",
    once: true,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      var cur = state.cur;
      if (cur !== null) {
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        if (_music.music.fall) {
          _music.music.fall();
        }
        var index = 0;
        var bottom = cur.fall(index);
        while ((0, _unit.want)(bottom, state.matrix)) {
          bottom = cur.fall(index);
          index++;
        }
        var matrix = JSON.parse((0, _stringify2.default)(state.matrix));
        bottom = cur.fall(index - 2);
        store.commit("moveBlock", bottom);
        var shape = bottom.shape;
        var xy = bottom.xy;
        shape.forEach(function (m, k1) {
          return m.forEach(function (n, k2) {
            if (n && xy[0] + k1 >= 0) {
              var line = matrix[xy[0] + k1];
              line[xy[1] + k2] = 1;
              matrix[xy[0] + k1] = line;
            }
          });
        });
        store.commit("drop", true);
        setTimeout(function () {
          store.commit("drop", false);
        }, 100);
        _states2.default.nextAround(matrix);
      } else {
        _states2.default.start();
      }
    }
  });
};

var up = function up(store) {
  store.commit("key_drop", false);
  _event2.default.up({
    key: "space"
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _event = __webpack_require__(7);

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
    _event2.default.down({
        key: 'x',
        once: true,
        callback: function callback() {
            store.commit('clearLines', store.state.clearLines + 1);
        }
    });
};

var up = function up(store) {
    _event2.default.up({
        key: 'x'
    });
};

exports.default = {
    down: down,
    up: up
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(42);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(58);

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__(10);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(0);

__webpack_require__(57);

var _unit = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _unit.subscribeRecord)(_store2.default);
_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#root',
  render: function render(h) {
    return h(_App2.default);
  },
  store: _store2.default
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _block = __webpack_require__(43);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = {
  nextBlock: function nextBlock(state, data) {
    if (!data) {
      data = (0, _unit.getNextType)();
    }
    state.next = data;
  },
  moveBlock: function moveBlock(state, data) {
    state.cur = data.reset === true ? null : new _block2.default(data);
  },
  speedStart: function speedStart(state, data) {
    state.speedStart = data;
  },
  speedRun: function speedRun(state, data) {
    state.speedRun = data;
  },
  startLines: function startLines(state, data) {
    state.startLines = data;
  },
  matrix: function matrix(state, data) {
    state.matrix = data;
  },
  lock: function lock(state, data) {
    state.lock = data;
  },
  clearLines: function clearLines(state, data) {
    state.clearLines = data;
  },
  points: function points(state, data) {
    state.points = data;
  },
  max: function max(state, data) {
    state.max = data;
  },
  reset: function reset(state, data) {
    state.reset = data;
  },
  drop: function drop(state, data) {
    state.drop = data;
  },
  pause: function pause(state, data) {
    state.pause = data;
  },
  music: function music(state, data) {
    state.music = data;
  },
  focus: function focus(state, data) {
    state.focus = data;
  },
  key_drop: function key_drop(state, data) {
    state.keyboard['drop'] = data;
  },
  key_down: function key_down(state, data) {
    state.keyboard['down'] = data;
  },
  key_left: function key_left(state, data) {
    state.keyboard['left'] = data;
  },
  key_right: function key_right(state, data) {
    state.keyboard['right'] = data;
  },
  key_rotate: function key_rotate(state, data) {
    state.keyboard['rotate'] = data;
  },
  key_reset: function key_reset(state, data) {
    state.keyboard['reset'] = data;
  },
  key_music: function key_music(state, data) {
    state.keyboard['music'] = data;
  },
  key_pause: function key_pause(state, data) {
    state.keyboard['pause'] = data;
  },
  controlMode: function controlMode(state, data) {
    state.controlMode = data;
  }
};
exports.default = mutations;

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clear.70566a6.wav";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fall.a359fd0.wav";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameover.cef7e56.wav";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gamestart.634a8ea.wav";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/move.04f65d1.wav";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/music.75c4bc1.mp3";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate.da4c6a2.wav";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(66),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(172),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: {
      'mobile-bg': _vm.isMobile
    },
    style: (_vm.size),
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('Settings'), _vm._v(" "), _c('div', {
    staticClass: "rect",
    class: _vm.drop ? 'drop' : ''
  }, [_c('Decorate'), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('Matrix', {
    attrs: {
      "propMatrix": _vm.matrix,
      "cur": _vm.cur,
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('Logo', {
    attrs: {
      "cur": !!_vm.cur,
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('Point', {
    attrs: {
      "cur": !!_vm.cur,
      "max": _vm.max,
      "point": _vm.points
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.pContent)
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.cur ? _vm.clearLines : _vm.startLines
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.level)
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.cur ? _vm.speedRun : _vm.speedStart,
      "length": 1
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextText)
    }
  }), _vm._v(" "), _c('Next', {
    attrs: {
      "data": _vm.next
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Music', {
    attrs: {
      "data": _vm.music
    }
  }), _vm._v(" "), _c('Pause', {
    attrs: {
      "data": _vm.pause
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('svg', {
    staticStyle: {
      "position": "absolute",
      "width": "0",
      "height": "0",
      "overflow": "hidden"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "seal-roughness",
      "x": "-20%",
      "y": "-20%",
      "width": "140%",
      "height": "140%"
    }
  }, [_c('feTurbulence', {
    attrs: {
      "type": "fractalNoise",
      "baseFrequency": "0.05",
      "numOctaves": "2",
      "result": "noise"
    }
  }), _vm._v(" "), _c('feDisplacementMap', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "noise",
      "scale": "2",
      "xChannelSelector": "R",
      "yChannelSelector": "G"
    }
  })], 1)])]), _vm._v(" "), (_vm.isMobile && _vm.controlMode === 'button') ? _c('Keyboard') : _vm._e(), _vm._v(" "), _c('Guide'), _vm._v(" "), _c('Sutra')], 1)
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "sutra-container"
  }, [_c('div', {
    ref: "content",
    staticClass: "sutra-content",
    style: (_vm.contentStyle)
  }, [_c('div', {
    staticClass: "sutra-text-flow"
  }, [_c('span', {
    staticClass: "sutra-title"
  }, [_vm._v("《金刚经》")]), _vm._v(" "), _c('span', {
    staticClass: "history-text"
  }, [_vm._v(_vm._s(_vm.historyText))]), _vm._v(" "), (_vm.activeChar) ? _c('span', {
    ref: "activeWrapper",
    staticClass: "active-char-wrapper"
  }, [_c('span', {
    staticClass: "active-char",
    style: (_vm.activeCharStyle)
  }, [_vm._v(_vm._s(_vm.activeChar))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button",
    class: _vm.color + ' ' + _vm.size
  }, [_c('i', {
    class: {
      'active': _vm.active
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard",
    style: ('margin-top:' + _vm.fillingNum + 'px')
  }, [_c('div', {
    staticClass: "button-row primary-row"
  }, [_c('div', {
    staticClass: "keyboard-dpad"
  }, [_c('div', {
    staticClass: "dpad-top"
  }, [_c('vbutton', {
    ref: "dom_left",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelLeft,
      "active": _vm.keyboard['left']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_right",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelRight,
      "active": _vm.keyboard['right']
    }
  })], 1), _vm._v(" "), _c('vbutton', {
    ref: "dom_down",
    staticClass: "dpad-down",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelDown,
      "active": _vm.keyboard['down']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "keyboard-action"
  }, [_c('vbutton', {
    ref: "dom_rotate",
    staticClass: "action-rotate",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.rotation,
      "active": _vm.keyboard['rotate']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_space",
    staticClass: "action-drop",
    attrs: {
      "color": "blue",
      "size": "s1",
      "label": _vm.labelDropSpace,
      "active": _vm.keyboard['drop']
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.number
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decorate"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('span', {
      class: 'num-' + item
    }, [_vm._v(_vm._s(item === 'n' ? '' : (item === 'd' || item === 'd_c' ? ':' : item)))])
  }))
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobile),
      expression: "!isMobile"
    }]
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide right"
  }, [_c('div', {
    staticClass: "msg"
  }, [_c('div', {
    staticClass: "control-section"
  }, [_c('div', {
    staticClass: "arrow-cluster"
  }, [_c('div', {
    staticClass: "arrow-row top"
  }, [_c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("↑")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("旋")])])]), _vm._v(" "), _c('div', {
    staticClass: "arrow-row bottom"
  }, [_c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("←")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("左")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("↓")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("下")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("→")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("右")])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-cluster"
  }, [_c('div', {
    staticClass: "key-wrapper space-wrapper"
  }, [_c('div', {
    staticClass: "key-cap space"
  }, [_vm._v("Space")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("落")])])]), _vm._v(" "), _c('div', {
    staticClass: "func-cluster"
  }, [_c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("音")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("P")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("止")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("复")])])])])])])
}]}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg music",
    class: _vm.data ? '' : 'c'
  })
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo",
    style: ('display:' + _vm.display)
  }, [_c('div', {
    staticClass: "bg dragon",
    class: _vm.style
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleCenter)
    },
    on: {
      "click": _vm.start,
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg pause",
    class: {
      'c': _vm.showPause
    }
  })
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next"
  }, _vm._l((_vm.block), function(item, index) {
    return _c('div', _vm._l((item), function(e, k2) {
      return _c('b', {
        class: e ? 'active type-' + e : ''
      }, [_vm._v("德")])
    }))
  }))
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMobile) ? _c('div', {
    staticClass: "settings-wrapper"
  }, [_c('div', {
    staticClass: "settings-btn",
    on: {
      "click": _vm.toggleMenu,
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      },
      "touchend": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n    ⚙️ 设置\n  ")]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "settings-menu",
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      },
      "touchend": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "menu-header"
  }, [_c('span', [_vm._v("菜单")]), _vm._v(" "), _c('span', {
    staticClass: "close-btn",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("❌")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.triggerAction('r')
      }
    }
  }, [_vm._v("🔄 重置游戏")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.triggerAction('s')
      }
    }
  }, [_vm._v("🔊 音效: " + _vm._s(_vm.music ? '开' : '关'))]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": _vm.toggleControlMode
    }
  }, [_vm._v("🕹️ 操控模式: " + _vm._s(_vm.controlMode === 'button' ? '按键' : '触屏'))]), _vm._v(" "), _c('div', {
    staticClass: "menu-item score-title"
  }, [_vm._v("🏆 当前分数: " + _vm._s(_vm.points))])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports) {

module.exports = {
	"lan": [
		"cn",
		"en",
		"fr",
		"fa"
	],
	"default": "cn",
	"data": {
		"title": {
			"cn": "積德消業",
			"en": "積德消業",
			"fr": "T E T R I S",
			"fa": "خانه سازی"
		},
		"titleCenter": {
			"cn": "游戲<br/>開始",
			"en": "游戲<br/>開始",
			"fr": "游戲<br/>開始",
			"fa": "游戲<br/>開始"
		},
		"point": {
			"cn": "行善<small>SCORE</small>",
			"en": "行善",
			"fr": "Score",
			"fa": "امتیاز"
		},
		"highestScore": {
			"cn": "頂点<small>PEAK</small>",
			"en": "頂点",
			"fr": "Max",
			"fa": "حداکثر"
		},
		"lastRound": {
			"cn": "前世<small>LAST</small>",
			"en": "前世",
			"fr": "Dernier Tour",
			"fa": "آخرین دور"
		},
		"cleans": {
			"cn": "消業<small>CLEAR</small>",
			"en": "消業",
			"fr": "Lignes",
			"fa": "پاک کرد"
		},
		"level": {
			"cn": "境界<small>LEVEL</small>",
			"en": "境界",
			"fr": "Difficulté",
			"fa": "سطح"
		},
		"startLine": {
			"cn": "開始<small>START</small>",
			"en": "開始",
			"fr": "Ligne Départ",
			"fa": "خط شروع"
		},
		"next": {
			"cn": "来者<small>NEXT</small>",
			"en": "来者",
			"fr": "Prochain",
			"fa": "بعدی"
		},
		"pause": {
			"cn": "停<small>PAUSE</small>",
			"en": "Pause",
			"fr": "Pause",
			"fa": "مکث"
		},
		"rest": {
			"cn": "息<small>REST</small>",
			"en": "Rest",
			"fr": "Repos",
			"fa": "استراحت"
		},
		"sound": {
			"cn": "音<small>SOUND</small>",
			"en": "Sound",
			"fr": "Sonore",
			"fa": "صدا"
		},
		"reset": {
			"cn": "悔<small>RESET</small>",
			"en": "Reset",
			"fr": "Réinitialiser",
			"fa": "ریست"
		},
		"rotation": {
			"cn": "转<small>ROTATE</small>",
			"en": "Turn",
			"fr": "Rotation",
			"fa": "چرخش"
		},
		"left": {
			"cn": "左<small>LEFT</small>",
			"en": "Left",
			"fr": "Gauche",
			"fa": "چپ"
		},
		"right": {
			"cn": "右<small>RIGHT</small>",
			"en": "Right",
			"fr": "Droite",
			"fa": "راست"
		},
		"down": {
			"cn": "落<small>DOWN</small>",
			"en": "Drop",
			"fr": "Bas",
			"fa": "پایین"
		},
		"drop": {
			"cn": "坠<small>DROP</small>",
			"en": "Fall",
			"fr": "Tomber",
			"fa": "سقوط"
		}
	}
};

/***/ })
],[83]);


// WEBPACK FOOTER //
// static/js/app.8927f8e92ae6ed71efde.js